import _ from "lodash";
import {
  CalendarOutlined,
  AttendanceOutlined,
  ClassProgressSummaryOutlined,
  FamilyOutlined,
  GridOutlined,
  InsightsOutlined,
  JournalOutlined,
  TickFrameOutlined,
  LeLibraryOutlined,
  ProgressReportOutlined,
  SettingsOutlined,
  TeacherResourceOutlined,
  UnitLibraryOutlined,
  UnitPlanOutlined,
  AssessmentandEvaluationOutlined,
  PolicyTickOutlined,
  NotificationSettingsOutlined,
  AtlDuotone,
  SortOutlined,
  AcademicSetupDuotone,
  PurposeOfIntegrationDuotone,
  InsightsSquareOutlined,
  ClassSettingsOutlined,
  KeyRelatedConceptsDuotone,
  SubjectGenericDuotone,
  LearnerProfileDuotone,
  ProgrammeofInquiryDuotone,
  ThemeDescriptorInsightsDuotone,
  AssessmentOutlined,
  StudentEvaluateOutlined,
  Integrations3D,
  Goals3D,
  StaffPermissions3D,
  Transcripts3D,
  ClipboardPencilLinesDuotone,
  SpiralBookLinesDuotone,
  AssessmentsDuotone,
  ProgressReportDuotone,
  OpenBookDuotone,
  SummativeAssessmentDuotone,
  ObjectivesDuotone,
  DifferentiationDuotone,
  LearningStandardsDuotone,
  LeAndTeachingStrategiesDuotone,
  SubjectOverviewDuotone,
  GlobalContextDuotone,
  TimelineDuotone,
  AttendanceClipboardDuotone,
  BinDuotone,
  School3D,
} from "@toddle-edu/ds-icons";
//Here, we can't import Component from "UIComponents" as it is breaking other dependencies from Utils folder
import CurriculumProgramLogo from "AppComponents/CurriculumProgramLogo";
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "Hooks";
import { getRecentSearches } from "services/localStorage";

import ACLStore from "lib/aclStore";
import classes from "./Utils.scss";
import { colors } from "@toddle-edu/ds-theme";
import { DESIGNATION_CONSTANTS_MAP } from "modules/Services";
import { getIsLearningCoursesEnabled } from "Teacher/routes/LearningCourses/modules/Utils";
import { store } from "store/createStore";
import {
  getDesignationIdFromUserDetails,
  getIsAdminByRole,
} from "lib/staffPermissionUtils";
import {
  generateConfigurationUid,
  getOrganizationCurriculumProgramsFromCache,
} from "modules/CommonGraphqlHelpers";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { parseConfigurationValue } from "Utils";
import { readConfigurationFragmentByUID } from "ChildrenPage/modules/ChildrenPageGraphqlHelpers";
import { SENTRAL_PERMISSION_CONFIGURATIONS } from "Login/components/SentralPortalModal/SentralPortalUtils";
import {
  getAdminPanelModuleAccessCurriculumIds,
  getHomeModuleAccessCurriculumIds,
  getAdminPortalNodeVisibilityStatusByUID,
} from "Administrator/modules/Utils";
import { isEducatorCenterRevampParentPermEnabled } from "AdminEducatorCenterV2/modules/AdminEducatorCenterV2Utils";
import {
  ENABLE_BEHAVIOUR_MODULE_IN_ADMIN_PORTAL,
  ENABLE_BEHAVIOUR_MODULE_PERM,
  ENABLE_BEHAVIOUR_SETUP_CARD,
  BEHAVIOUR_SETUP_ACCESS_PERMISSION,
  ADMIN_PORTAL_ACCESS_PERMISSION,
  BIN_ACCESS_PERM,
  SCHOOL_LIBRARY_VIEW_PERM,
  SCHOOL_LIBRARY_PERM,
  SNPv2_PERM,
  SNPv2_TEACHER_MODULE_PERM,
  SNPv2_ACCESS_PERMISSION,
  TODDLE_ANALYTICS_USER_BASED_ACCESS_PERM,
  ASSIGNMENTS_ACCESS_PERMISSION,
  PLANNING_INSIGHTS_PROGRAMME_LEVEL_VIEW_PERMISSION,
  VIEW_SCHOOL_POLICIES_AND_RESOURCES_MODULE_PERMISSION,
  CAN_VIEW_STUDENT_GOALS,
  PROGRESS_REPORTS_PROGRAMME_LEVEL_VIEW_PERMISSION,
  PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
  TRANSCRIPT_ADMIN_LEVEL_VIEW_PERMISSION,
  IBIS_REGISTRATION_ACCESS_PERMISSION,
  ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
  CLASS_SETTINGS_ACCESS_PERMISSION,
  MODULE_SETTINGS_ACCESS_PERMISSION,
  CAN_VIEW_CALENDAR_MODULE_SETTING,
  CAN_VIEW_CONTINUUM_MODULE_SETTING,
  ENGAGEMENT_ANALYTICS_PERMISSION,
  PERFORMANCE_ANALYTICS_PERMISSION,
  MODULE_USAGE_ANALYTICS_PERMISSION,
  BEHAVIOUR_ANALYTICS_PERMISSION,
  ATTENDANCE_ANALYTICS_PERMISSION,
  TODDLE_ANALYTICS_PERMISSION,
  BEHAVIOUR_DASHBOARD_ACCESS_PERMISSION,
  ENABLE_RNP_CONSUMPTION_IN_BEHAVIOUR,
  TODDLE_2_O_PERMISSION,
  LEARNING_COURSE_PERM,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS,
} from "Constants/permissionConstants";

import {
  HOME_PAGE_FEATURE_ANNOUNCEMENT,
  HOME_PAGE_FEATURE_ATTENDANCE,
  HOME_PAGE_FEATURE_CALENDAR,
  HOME_PAGE_FEATURE_CLASSROOM_TODO,
  HOME_PAGE_FEATURE_FAMILY_COMMUNICATION,
  HOME_PAGE_FEATURE_SNP,
  HOME_PAGE_FEATURE_EDUCATOR_CENTER,
  HOME_PAGE_FEATURE_PROGRESS_REPORT,
  HOME_PAGE_FEATURE_HOMEROOM,
  HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT,
  HOME_PAGE_FEATURE_MESSAGING,
  HOME_PAGE_FEATURE_GOALS,
  HOME_PAGE_FEATURE_SCHOOL_LIBRARY,
  ESF_SENTRAL_WELLBEING,
  ESF_SENTRAL_ATTENDANCE,
  ESF_SENTRAL_POLICIES,
  ESF_SENTRAL_TIMETABLE,
  ESF_SENTRAL_PXP,
  ESF_SENTRAL_NEWSFEED,
  ESF_SENTRAL_DAILY_NOTICE,
} from "Courses/components/TeacherCourses/Constants";
import {
  getFeatureIcon,
  FEATURE_STYLE_MAP,
} from "Courses/components/TeacherCourses/Utils";
import { Avatar } from "@toddle-edu/ds-web";
import AssessmentIcon from "UIComponents/AssessmentIcon";
import { getBehaviourNomenclatureFromCache } from "Login/routes/Administrator/routes/SchoolSetup/routes/BehaviourConfiguration/modules/BehaviourConfigurationGraphqlHelpers";
import {
  getOrganizationId,
  getSelectedAcademicYearId,
  getOrganizationCurriculumPrograms,
} from "modules/CommonSelectors";
import {
  CORE_TYPES,
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  ROLE_VISITOR,
  STAFF,
  SUBJECT_TYPE_CAS,
  SUBJECT_TYPE_EE,
  SUBJECT_TYPE_RP,
  SUBJECT_TYPE_SLR,
  SUBJECT_TYPE_CE,
} from "Constants/stringConstants";
import { isMessagingV2Enabled } from "MessagingV2/modules/Utils";
import { PROJECT_TYPE_LABEL_MAP_V2 } from "Teacher/routes/Projects/modules/ProjectModules";
import {
  getIconComponent,
  stylesV2 as projectGroupIconStyles,
} from "Courses/components/components/GroupedProjectGroupList/GroupedProjectGroupList";
import {
  PROJECT_GROUP_TYPE_DP_CAS,
  PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
  PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
  PROJECT_GROUP_TYPE_DP_EE,
  PROJECT_GROUP_TYPE_PERSONAL,
  PROJECT_GROUP_TYPE_COMMUNITY,
  PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
  PROJECT_GROUP_TYPE_DP_G4_PROJECT,
  PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
  PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
  PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
  PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
} from "Teacher/routes/Projects/Constants/stringConstants";
import { checkIfPermissionIsEnabledInAnyCurriculum } from "Platform/modules/PlatformUtils";

import { CourseIcon } from "GlobalHeader/components/JumpToFeature/components/CourseFeed/components";
import ACLStorage from "lib/aclService";
import { getConfigurationsFromControlParameters } from "@toddle-edu/common-utils";
import {
  getProgramTypeFromLocalStorageBasedOnContext,
  getProjectGroupTypeBasedOnContext,
} from "lib/aclService/modules/Utils";
import { getSettingValue } from "modules/PermissionModule";
import { ROUTE_TYPES } from "modules/NavigationModule/NavigationConstants";
import {
  getIsIBISUIRevampEnabled,
  getIsNewAdminUIEnabled,
  isModuleSearchEnabledInGlobalSearch,
  isInsightsSearchEnabledInGlobalSearch,
} from "Utils/ACLStoreUtils";
import { generateRnPContextsByLevel } from "Utils/RnPHelpers";
import { getCanAccessBehaviourDashboardInRnPOrg } from "Utils/BehaviourUtils";
import { getCanAccessStudentProfile } from "Utils/ProfileUtils";

const TITLE_FALLBACK_TO_EMAIL_MODULES = ["STUDENT_PROFILE"];

const PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG = {
  controlParameterType: "MODULE_SETTINGS",
  controlParameter: PLANNING_INSIGHTS_PROGRAMME_LEVEL_VIEW_PERMISSION,
  contextType: "CURRICULUM_PROGRAM",
};

const PROGRESS_REPORTS_PROGRAMME_LEVEL_CONTROL_PARAMETER_CONFIG = {
  controlParameterType: "MODULE_SETTINGS",
  controlParameter: PROGRESS_REPORTS_PROGRAMME_LEVEL_VIEW_PERMISSION,
  contextType: "CURRICULUM_PROGRAM",
};

const PROGRESS_REPORTS_ADMIN_LEVEL_CONTROL_PARAMETER_CONFIG = {
  controlParameterType: "MODULE_SETTINGS",
  controlParameter: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
  contextType: "CURRICULUM_PROGRAM",
};

const TRANSCRIPTS_ADMIN_LEVEL_CONTROL_PARAMETER_CONFIG = {
  controlParameterType: "MODULE_SETTINGS",
  controlParameter: TRANSCRIPT_ADMIN_LEVEL_VIEW_PERMISSION,
};

const commonStyle = {
  iconStyle: {
    height: 40,
    borderRadius: 8,
    width: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const staffPermissionEnabledAdminOnlyModule = () => {
  if (ACLStore.isStaffPermissionEnabled()) {
    return (
      getDesignationIdFromUserDetails() !==
      DESIGNATION_CONSTANTS_MAP.SCHOOL_ADMIN.id
    );
  }
  return false;
};

const getProgressReportSearchV2Enabled = () => {
  return ACLStore.can("GlobalSearch:ReportsSearchV2");
};

export const getIsClassSearchV2Enabled = () => {
  return ACLStore.can("GlobalSearch:ClassSearchV2");
};

export const getIsClassSearchV3Enabled = () => {
  return ACLStore.can("GlobalSearch:ClassSearchV3");
};

export const getIsProjectGroupSearchEnabled = () => {
  return ACLStore.can("GlobalSearch:EnableProjectsSearch");
};

export const getIsInsightsSearchV2Enabled = () => {
  return ACLStore.can("GlobalSearch:InsightsSearchV2");
};

export const CURRICULUM_PROGRAMME_ICON_STYLES = {
  IB_PYP: {
    color: colors.decorativeSurfaceFourL,
    className: classes.pypModule,
    textColor: colors.pink500,
  },
  IB_MYP: {
    color: colors.decorativeSurfaceTwoL,
    className: classes.mypModule,
    textColor: colors.violet500,
  },
  UBD: {
    color: colors.decorativeSurfaceOneL,
    className: classes.ubdModule,
    textColor: colors.blue400,
  },
  IB_DP: {
    color: colors.decorativeSurfaceThreeL,
    className: classes.dpModule,
    textColor: colors.yellow400,
  },
};

export const CURRICULUM_PROGRAMME_DUOTONE_ICON_COLOR_MAPPING = {
  IB_PYP: "pink",
  IB_MYP: "violet",
  UBD: "teal",
  IB_DP: "yellow",
};

const getInsightsBasedModulesPath = type => {
  return getIsInsightsSearchV2Enabled()
    ? [
        { label: "variable", value: "courseName" },
        { label: "text", value: "teacherHomePage:planning_insights" },
      ]
    : typesConfig[type]?.path;
};

const ALL_CURRICULUM_PROGRAMS = ["IB_PYP", "IB_MYP", "IB_DP", "UBD"];
/**
 * this is constants of all modules searchable
 */

/**
 * NOTE:
 * If you are adding new module perms or updating existing module perms in typesConfig,
 * update the same in the following permission constants
 * 1. PRE_LOAD_ORGANIZATION_LEVEL_STAFF_PERMISSIONS
 * 2. PRE_LOAD_CURRICULUM_LEVEL_STAFF_PERMISSIONS
 *
 * Reason: These permissions will be used to handle module level permissions in
 * JumpTo and Global search modal when they are getting rendered for the very first time.
 */

const GradeNamesDisplay = ({ gradeNames = [] }) =>
  !_.isEmpty(gradeNames) ? (
    <MoreItemWithToolTip items={gradeNames} length={1} trigger={["hover"]} />
  ) : null;

const COURSE_TYPE_LABEL_MAP = {
  BLUEPRINT_COURSE: "course:blueprint_course",
  TEACHER_COURSE: "course:teacher_course",
};

const CourseSubtitleDisplay = ({ courseType, gradeNames = [] }) => {
  const { t } = useI18n(["course"]);
  const courseTypeLabel = COURSE_TYPE_LABEL_MAP[courseType]
    ? t(COURSE_TYPE_LABEL_MAP[courseType])
    : "";
  return (
    <div>
      <span>{courseTypeLabel}</span>
      {!_.isEmpty(gradeNames) && (
        <>
          <span> • </span>
          <MoreItemWithToolTip
            items={gradeNames}
            length={1}
            trigger={["hover"]}
          />
        </>
      )}
    </div>
  );
};

export const typesConfig = {
  COURSE: {
    id: "COURSE",
    title: "common:course_plural",
    subTitle: "teacherHomePage:units_of_inquiry",
    searchText: [],
    order: 23,
    perms: [GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.CLASSES_SEARCH],
    isPath: true,
    getCustomPath: () => {
      if (getIsClassSearchV3Enabled()) {
        return [
          {
            label: "component",
            Component: GradeNamesDisplay,
            variables: ["gradeNames"],
            skipSlash: true,
          },
        ];
      }
      return null;
    },
    path: [{ label: "text", value: "teacherHomePage:units_of_inquiry" }],
  },
  LEARNING_COURSE: {
    id: "LEARNING_COURSE",
    title: "course:courses",
    subTitle: "course:courses",
    perms: [GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.COURSES_SEARCH],
    isPath: true,
    order: 24,
    getCustomPath: () => [
      {
        label: "component",
        Component: CourseSubtitleDisplay,
        variables: ["courseType", "gradeNames"],
        skipSlash: true,
      },
    ],
  },
  UNIT_PLAN: {
    id: "UNIT_PLAN",
    title: "common:unit_plural",
    subTitle: "teacherHomePage:units_of_inquiry",
    searchText: [],
    perms: [GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.UNITS_SEARCH],
    isPath: true,
    path: [
      { label: "variable", value: "courseName" },
      { label: "text", value: "teacherHomePage:units_of_inquiry" },
    ],
  },
  STUDENT_PROFILE: {
    id: "STUDENT_PROFILE",
    title: "common:student_plural",
    subTitle: "teacherHomePage:student_profile_sentence_case",
    searchText: [],
    customIsIncluded: getConfigValueProps => {
      const {
        curriculumProgramId,
        userCurriculumProgramsIds,
        userType,
      } = getConfigValueProps;

      const curriculumProgramIds =
        curriculumProgramId === "ALL"
          ? userCurriculumProgramsIds
          : [curriculumProgramId];

      return getCanAccessStudentProfile({
        userType,
        curriculumProgramIds,
        applyCurriculumContextForProfileCP: true,
      });
    },
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:student_profile_sentence_case" },
    ],
    perms: [GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.STUDENTS_SEARCH],
  },
  FAMILY_PROFILE: {
    id: "FAMILY_PROFILE",
    title: "common:family_member_plural",
    subTitle: "teacherHomePage:family_profile_sentence_case",
    searchText: [],
    perms: [
      "TeacherPortal:FamilyProfile",
      GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.FAMILY_SEARCH,
    ],
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:family_profile_sentence_case" },
      {
        label: "text",
        value: "teacherHomePage:parent_of_student",
        variablesForLocale: ["studentFullName"],
      },
      {
        label: "component",
        Component: ({ childrenList = [] }) => (
          <MoreItemWithToolTip
            items={childrenList}
            length={1}
            trigger={["hover"]}
          />
        ),
        variables: ["childrenList"],
        skipSlash: true,
      },
    ],
  },
  TEACHER_PROFILE: {
    id: "TEACHER_PROFILE",
    title: "common:staff_members_plural",
    subTitle: "teacherHomePage:staff_profile",
    searchText: [],
    perms: [GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.STAFF_SEARCH],
    isPath: true,
    path: [{ label: "text", value: "teacherHomePage:staff_profile" }],
  },
  CLASSROOM: {
    id: "CLASSROOM",
    title: "common:classroom",
    subTitle: "",
    searchText: [],
  },
  PARENT: {
    id: "PARENT",
    title: "",
    subTitle: "teacherHomePage:student_profile",
    searchText: [],
  },
  LE: {
    id: "LE",
    title: "common:task_plural",
    subTitle: "common:le_and_assessments",
    searchText: [],
    isPath: true,
    path: [
      { label: "variable", value: "courseName" },
      { label: "text", value: "teacherHomePage:units_of_inquiry" },
      { label: "variable", value: "unitName" },
    ],
    perms: [GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.TASKS_SEARCH],
  },
  IB_PYP: {
    id: "IB_PYP",
    title: "common:pyp_home",
    curriculumPrograms: ["IB_PYP"],
    order: 1,
    excludeCurriculumIndicator: true,
  },
  IB_MYP: {
    id: "IB_MYP",
    title: "common:myp_home",
    curriculumPrograms: ["IB_MYP"],
    order: 1,
    excludeCurriculumIndicator: true,
  },
  UBD: {
    id: "UBD",
    title: "common:ubd_home",
    curriculumPrograms: ["UBD"],
    order: 1,
    excludeCurriculumIndicator: true,
  },
  IB_DP: {
    id: "IB_DP",
    title: "common:dp_home",
    curriculumPrograms: ["IB_DP"],
    order: 1,
    excludeCurriculumIndicator: true,
  },
  HOME_SCHOOL_LIBRARY_MODULE: {
    id: "HOME_SCHOOL_LIBRARY_MODULE",
    title: "common:school_library",
    subTitle: "common:home",
    searchText: ["scho", "libr", "book", "resou"],
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: SCHOOL_LIBRARY_VIEW_PERM,
      contextType: "CURRICULUM_PROGRAM", //contextType represents the type of context in which permission value will be evaluated.
    },
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 10,
  },
  HOME_ANNOUNCEMENT_MODULE: {
    id: "HOME_ANNOUNCEMENT_MODULE",
    title: "common:announcement_plural",
    subTitle: "common:home",
    searchText: ["anno", "circ", "noti"],
    perms: ["Common:Announcement"],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 4,
  },
  HOME_BEHAVIOUR_MANAGEMENT_MODULE: {
    id: "HOME_BEHAVIOUR_MANAGEMENT_MODULE",
    title: "behaviour:behaviour_management",
    subTitle: "common:home",
    searchText: ["behav", "manag", "well", "pasto"],
    perms: [ENABLE_BEHAVIOUR_MODULE_PERM],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 4,
    customIsIncluded: getConfigValueProps => {
      const isSentralWellbeingEnabled = isSentralConfigEnabled(
        getConfigValueProps,
        SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING
      );

      if (isSentralWellbeingEnabled) {
        return false;
      }

      const isRnPEnabledInBehaviour = ACLStore.can(
        [
          ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
          ENABLE_RNP_CONSUMPTION_IN_BEHAVIOUR,
        ],
        "all"
      );

      if (isRnPEnabledInBehaviour) {
        const { curriculumProgramId } = getConfigValueProps;

        return getCanAccessBehaviourDashboardInRnPOrg({
          curriculumProgramId,
        });
      }

      return getConfigValue({
        ...getConfigValueProps,
        configuration: ENABLE_BEHAVIOUR_MODULE_PERM,
      });
    },
  },
  ESF_SENTRAL_WELLBEING: {
    id: "ESF_SENTRAL_WELLBEING",
    title: "common:wellbeing",
    subTitle: "common:powered_by_sentral",
    searchText: ["behav", "manag", "well", "pasto"],
    perms: [SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 4,
  },
  ESF_SENTRAL_ATTENDANCE: {
    id: "ESF_SENTRAL_ATTENDANCE",
    title: "common:attendance",
    subTitle: "common:powered_by_sentral",
    searchText: ["attend", "roll", "call", "abse", "pres"],
    perms: [SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 5,
  },
  ESF_SENTRAL_TIMETABLE: {
    id: "ESF_SENTRAL_TIMETABLE",
    title: "common:timetable",
    subTitle: "common:powered_by_sentral",
    searchText: ["timet", "sched"],
    perms: [SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 11,
  },
  ESF_SENTRAL_POLICIES: {
    id: "ESF_SENTRAL_POLICIES",
    title: "common:policies_and_resources",
    subTitle: "common:powered_by_sentral",
    searchText: ["scho", "poli", "reso"],
    perms: [SENTRAL_PERMISSION_CONFIGURATIONS.POLICIES_AND_RESOURCES],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 33,
  },
  ESF_SENTRAL_PXP: {
    id: "ESF_SENTRAL_PXP",
    title: "common:pxp",
    subTitle: "common:powered_by_sentral",
    searchText: ["pxp", "abse", "pres"],
    perms: [SENTRAL_PERMISSION_CONFIGURATIONS.PXP],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 48,
  },
  ESF_SENTRAL_NEWSFEED: {
    id: "ESF_SENTRAL_NEWSFEED",
    title: "common:newsfeed",
    subTitle: "common:powered_by_sentral",
    searchText: ["news", "feed"],
    perms: [SENTRAL_PERMISSION_CONFIGURATIONS.NEWSFEED],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 49,
  },
  ESF_SENTRAL_DAILY_NOTICE: {
    id: "ESF_SENTRAL_DAILY_NOTICE",
    title: "common:daily_notices",
    subTitle: "common:powered_by_sentral",
    searchText: ["daily", "notice"],
    perms: [SENTRAL_PERMISSION_CONFIGURATIONS.NOTICE],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 50,
  },
  HOME_SCHOOL_POLICIES_AND_RESOURCES_MODULE: {
    id: "HOME_SCHOOL_POLICIES_AND_RESOURCES_MODULE",
    title: "common:school_policies_and_resources",
    subTitle: "common:home",
    searchText: ["scho", "poli", "reso"],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 33,
    customIsIncluded: getConfigValueProps => {
      const isSentralPoliciesAndResourcesEnabled = isSentralConfigEnabled(
        getConfigValueProps,
        SENTRAL_PERMISSION_CONFIGURATIONS.POLICIES_AND_RESOURCES
      );

      if (isSentralPoliciesAndResourcesEnabled) {
        return false;
      }

      const { curriculumProgramId } = getConfigValueProps;
      if (!isEducatorCenterRevampParentPermEnabled()) return false;

      if (ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION)) {
        return ACLStorage.getModuleSettingsValueByContext(
          VIEW_SCHOOL_POLICIES_AND_RESOURCES_MODULE_PERMISSION,
          _getContextsFromContextType({
            contextType: "CURRICULUM_PROGRAM",
            curriculumProgramId,
          })
        );
      } else {
        return getConfigValue({
          ...getConfigValueProps,
          configuration: "Common:EducatorCenterRevamp",
        });
      }
    },
  },
  HOME_HOMEROOM_MODULE: {
    id: "HOME_HOMEROOM_MODULE",
    title: "attendance:homeroom",
    subTitle: "common:home",
    searchText: ["home", "room", "pare"],
    perms: ["Common:Homeroom"],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 34,
  },
  HOME_ATTENDANCE_MODULE: {
    id: "HOME_ATTENDANCE_MODULE",
    title: "attendance:attendance_manager",
    subTitle: "common:home",
    searchText: ["atte", "roll", "call", "abse", "pres"],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 5,
    customIsExcluded: getConfigValueProps => {
      const isSentralAttendanceEnabled = isSentralConfigEnabled(
        getConfigValueProps,
        SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE
      );

      if (isSentralAttendanceEnabled) {
        return true;
      }

      const isAdminByRole = getIsAdminByRole();

      if (isAdminByRole) {
        return !getConfigValue({
          ...getConfigValueProps,
          configuration: "Common:AttendanceDashboard",
        });
      } else {
        return !getConfigValue({
          ...getConfigValueProps,
          configuration: "TeacherPortal:AttendanceDashboard",
        });
      }
    },
  },
  HOME_CLASSROOM_MODULE: {
    id: "HOME_CLASSROOM_MODULE",
    title: "classRoom:assignments_manager",
    subTitle: "common:home",
    searchText: ["class", "assig", "strea", "work", "homew", "disc", "zoo"],
    perms: ["Common:AssignmentsManager"],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 7,
  },
  HOME_CALENDAR_MODULE: {
    id: "HOME_CALENDAR_MODULE",
    title: "common:calendar",
    subTitle: "common:home",
    searchText: ["calen", "sche", "call", "zoo", "disc"],
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: CAN_VIEW_CALENDAR_MODULE_SETTING,
      contextType: "CURRICULUM_PROGRAM",
    },
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 6,
  },
  HOME_MESSAGING_MODULE: {
    id: "HOME_MESSAGING_MODULE",
    title: "teacherHomePage:messaging",
    subTitle: "common:home",
    searchText: ["mess", "chat", "comm"],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    customIsExcluded: () => {
      return !isMessagingV2Enabled();
    },
    order: 8,
  },
  HOME_FAMILY_MESSAGING_MODULE: {
    id: "HOME_FAMILY_MESSAGING_MODULE",
    title: "configuration:family_messaging",
    subTitle: "common:home",
    searchText: ["fam", "mess", "pare", "ptm", "talk"],
    perms: ["TeacherPortal:FamilyCommunications"],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 8,
  },
  HOME_STUDENT_GOALS_MODULE: {
    id: "HOME_STUDENT_GOALS_MODULE",
    title: "studentGoals:student_goals",
    subTitle: "common:home",
    searchText: ["stud", "goal", "obje", "tar"],
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: CAN_VIEW_STUDENT_GOALS,
      contextType: "CURRICULUM_PROGRAM",
    },
    permsCheckMode: "AND",
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 9,
  },
  HOME_PROGRESS_REPORTS_MODULE_UBD: {
    id: "HOME_PROGRESS_REPORTS_MODULE_UBD",
    title: "teacherHomePage:progress_report",
    subTitle: "common:home",
    searchText: ["prog", "resu", "asse", "rate"],
    controlParameterConfig: PROGRESS_REPORTS_PROGRAMME_LEVEL_CONTROL_PARAMETER_CONFIG,
    curriculumPrograms: [CURRICULUM_TYPE_UBD],
    order: 10,
  },
  HOME_PROGRESS_REPORTS_MODULE_MYP: {
    id: "HOME_PROGRESS_REPORTS_MODULE_MYP",
    title: "teacherHomePage:progress_report",
    subTitle: "common:home",
    searchText: ["prog", "resu", "asse", "rate"],
    controlParameterConfig: PROGRESS_REPORTS_PROGRAMME_LEVEL_CONTROL_PARAMETER_CONFIG,
    curriculumPrograms: [CURRICULUM_TYPE_MYP],
    order: 10,
  },
  HOME_PROGRESS_REPORTS_MODULE_DP: {
    id: "HOME_PROGRESS_REPORTS_MODULE_DP",
    title: "teacherHomePage:progress_report",
    subTitle: "common:home",
    searchText: ["prog", "resu", "asse", "rate"],
    controlParameterConfig: PROGRESS_REPORTS_PROGRAMME_LEVEL_CONTROL_PARAMETER_CONFIG,
    curriculumPrograms: [CURRICULUM_TYPE_DP],
    order: 10,
  },
  HOME_AUTH_EVALUATION: {
    id: "HOME_AUTH_EVALUATION",
    title: "teacherHomePage:authorizationEvaluation",
    subTitle: "common:home",
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: SNPv2_ACCESS_PERMISSION,
      contextType: "CURRICULUM_PROGRAM", //contextType represents the type of context in which permission value will be evaluated.
    },
    //BUG: For SnP, we are not checking number of cycles while deciding whether to show/hide the module
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 20,
  },
  ADMIN_PANEL_MODULE: {
    id: "ADMIN_PANEL_MODULE",
    title: "common:admin_portal",
    searchText: ["adm", "pane", "contr", "pref", "setu", "sett"],
    perms: ["AdminPortal"],
    order: 3,
    excludeCurriculumIndicator: true,
  },
  ADMIN_INTEGRATIONS_MODULE: {
    id: "ADMIN_INTEGRATIONS_MODULE",
    title: "common:integrations",
    subTitle: "common:admin_portal",
    searchText: ["inte", "turn"],
    order: 8,
    customIsExcluded: () => {
      return !getIsAdminByRole();
    },
  },
  ADMIN_ACADEMY_ANALYTICS_MODULE: {
    id: "ADMIN_ACADEMY_ANALYTICS_MODULE",
    title: "common:academy_analytics",
    subTitle: "common:admin_portal",
    searchText: ["acad", "analy", "dash", "repo"],
    perms: ["FeatureFlag:WorkrampAcademyAnalytics"],
    customIsExcluded: () => {
      return !getIsAdminByRole();
    },
    order: 8,
  },
  ADMIN_SCHOOL_SETUP_MODULE: {
    id: "ADMIN_SCHOOL_SETUP_MODULE",
    title: "teacherHomePage:school_setup",
    subTitle: "common:admin_portal",
    searchText: ["setu", "scho", "clas", "cour", "sync", "grad", "user"],
    order: 9,
    excludeCurriculumIndicator: true,
    customIsIncluded: ({ orgCurriculumPrograms }) => {
      if (!ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION)) {
        return ACLStore.can("AdminPortal");
      }
      return getAdminPortalNodeVisibilityStatusByUID({
        uid: "SCHOOL_SETUP",
        curriculumPrograms: orgCurriculumPrograms,
      });
    },
  },
  ADMIN_TRANSCRIPTS_MODULE: {
    id: "ADMIN_TRANSCRIPTS_MODULE",
    title: "common:transcripts",
    subTitle: "common:admin_portal",
    searchText: ["tran", "stud", "repo"],
    controlParameterConfig: TRANSCRIPTS_ADMIN_LEVEL_CONTROL_PARAMETER_CONFIG,
    excludedCurriculumPrograms: [CURRICULUM_TYPE_PYP],
    order: 10,
  },
  ADMIN_IB_E_COURSEWORK_MODULE: {
    id: "ADMIN_IB_E_COURSEWORK_MODULE",
    title: "teacherHomePage:ib_ecoursework",
    subTitle: "common:admin_portal",
    searchText: ["ib", "ecou", "work", "subm", "resu"],
    perms: ["Common:IbECoursework"],
    curriculumPrograms: [CURRICULUM_TYPE_DP],
    order: 9,
  },
  ADMIN_IBIS_REGISTRATION_MODULE: {
    id: "ADMIN_IBIS_REGISTRATION_MODULE",
    title: "teacherHomePage:ibis_exam_registration",
    subTitle: "common:admin_portal",
    searchText: ["ibis", "regi", "regis", "reg"],
    curriculumPrograms: [CURRICULUM_TYPE_DP],
    order: 9,
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: IBIS_REGISTRATION_ACCESS_PERMISSION,
      contextType: "CURRICULUM_PROGRAM",
    },
  },
  ADMIN_GRADEBOOK_MODULE: {
    id: "ADMIN_GRADEBOOK_MODULE",
    title: "common:gradebook",
    subTitle: "common:admin_portal",
    searchText: ["grad", "book", "mark", "repo"],
    perms: ["AdminPortal:Gradebook"],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 9,
  },
  HOME_GRADEBOOK_MODULE: {
    id: "HOME_GRADEBOOK_MODULE",
    title: "common:gradebook",
    subTitle: "common:home",
    searchText: ["grad", "book", "mark", "repo"],
    perms: ["AdminPortal:Gradebook"],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 9,
  },
  ADMIN_STAFF_ACCESS_PERMISSION_MODULE: {
    id: "ADMIN_STAFF_ACCESS_PERMISSION_MODULE",
    title: "common:staff_permissions",
    subTitle: "common:admin_portal",
    searchText: ["staff", "acce", "perm", "role"],
    perms: ["AdminPortal:StaffPermissions"],
    excludeCurriculumIndicator: true,
    order: 9,
  },
  ADMIN_ACADEMIC_SETUP_MODULE_PYP: {
    id: "ADMIN_ACADEMIC_SETUP_MODULE_PYP",
    title: "teacherHomePage:academic_setup",
    subTitle: "common:admin_portal",
    searchText: ["acade", "setu", "sns", "benc", "atl", "approa", "subj"],
    perms: ["AdminPortal"],
    curriculumPrograms: ["IB_PYP"],
    order: 10,
  },
  ADMIN_ACADEMIC_SETUP_MODULE_MYP: {
    id: "ADMIN_ACADEMIC_SETUP_MODULE_MYP",
    title: "teacherHomePage:academic_setup",
    subTitle: "common:admin_portal",
    searchText: ["acade", "setu", "sns", "benc", "atl", "approa", "subj"],
    perms: ["AdminPortal"],
    curriculumPrograms: ["IB_MYP"],
    order: 10,
  },
  ADMIN_ACADEMIC_SETUP_MODULE_UBD: {
    id: "ADMIN_ACADEMIC_SETUP_MODULE_UBD",
    title: "teacherHomePage:academic_setup",
    subTitle: "common:admin_portal",
    searchText: ["acade", "setu", "sns", "benc", "atl", "approa", "subj"],
    perms: ["AdminPortal"],
    curriculumPrograms: ["UBD"],
    order: 10,
  },
  ADMIN_ACADEMIC_SETUP_MODULE_DP: {
    id: "ADMIN_ACADEMIC_SETUP_MODULE_DP",
    title: "teacherHomePage:academic_setup",
    subTitle: "common:admin_portal",
    searchText: ["acade", "setu", "sns", "benc", "atl", "approa", "subj"],
    perms: ["AdminPortal"],
    curriculumPrograms: ["IB_DP"],
    order: 10,
  },
  ADMIN_TIMETABLE_MODULE: {
    id: "ADMIN_TIMETABLE_MODULE",
    title: "common:timetable",
    subTitle: "common:admin_portal",
    searchText: ["timet", "sched", "clas", "teac", "stud"],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 11,
    customIsExcluded: getConfigValueProps => {
      const isSentralTimetableEnabled = isSentralConfigEnabled(
        getConfigValueProps,
        SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE
      );

      if (isSentralTimetableEnabled) {
        return true;
      }

      return !getConfigValue({
        ...getConfigValueProps,
        configuration: "FeatureFlag:AdminTimetable",
      });
    },
  },
  ADMIN_PLANNING_INSIGHTS_MODULE: {
    id: "ADMIN_PLANNING_INSIGHTS_MODULE",
    title: "teacherHomePage:planning_insights",
    subTitle: "common:admin_portal",
    searchText: ["plan", "ins"],
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD"],
    order: 15,
  },
  ADMIN_PLANNING_INSIGHTS_MODULE_DP: {
    id: "ADMIN_PLANNING_INSIGHTS_MODULE_DP",
    title: "teacherHomePage:planning_insights",
    subTitle: "common:admin_portal",
    searchText: ["plan", "ins"],
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    curriculumPrograms: ["IB_DP"],
    order: 15,
  },
  HOME_PLANNING_INSIGHTS_MODULE: {
    id: "HOME_PLANNING_INSIGHTS_MODULE",
    title: "teacherHomePage:planning_insights",
    subTitle: "common:home",
    searchText: ["plan", "ins"],
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD"],
    order: 15,
  },
  HOME_PLANNING_INSIGHTS_MODULE_DP: {
    id: "HOME_PLANNING_INSIGHTS_MODULE_DP",
    title: "teacherHomePage:planning_insights",
    subTitle: "common:home",
    searchText: ["plan", "ins"],
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    curriculumPrograms: ["IB_DP"],
    order: 15,
  },
  ADMIN_BIN_MODULE: {
    id: "ADMIN_BIN_MODULE",
    title: "common:trash",
    subTitle: "common:admin_portal",
    searchText: ["bin", "arch", "rest", "undel", "dele", "tras"],
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: BIN_ACCESS_PERM,
      contextType: "CURRICULUM_PROGRAM", //contextType represents the type of context in which permission value will be evaluated.
    },
    order: 14,
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    customIsExcluded: staffPermissionEnabledAdminOnlyModule,
  },
  ADMIN_ANNOUNCEMENT_MODULE: {
    id: "ADMIN_ANNOUNCEMENT_MODULE",
    title: "common:announcement_plural",
    subTitle: "common:admin_portal",
    searchText: ["anno", "circ", "noti"],
    perms: ["AdminPortal:Circular"],
    order: 13,
    excludeCurriculumIndicator: true,
    customIsExcluded: staffPermissionEnabledAdminOnlyModule,
  },
  ADMIN_MESSAGING_MODULE: {
    id: "ADMIN_MESSAGING_MODULE",
    title: "common:messaging",
    subTitle: "common:admin_portal",
    searchText: ["mess", "chat", "comm"],
    perms: ["FeatureFlag:MessagingV2"],
    order: 13,
    customIsExcluded: () => {
      return !getIsAdminByRole();
    },
  },
  ADMIN_BEHAVIOUR_MANAGEMENT_MODULE: {
    id: "ADMIN_BEHAVIOUR_MANAGEMENT_MODULE",
    title: "behaviour:behaviour_management",
    subTitle: "common:admin_portal",
    searchText: ["behav", "manag", "well", "pasto"],
    perms: [
      ENABLE_BEHAVIOUR_MODULE_PERM,
      ENABLE_BEHAVIOUR_MODULE_IN_ADMIN_PORTAL,
    ],
    customIsIncluded: getConfigValueProps => {
      const isSentralWellbeingEnabled = isSentralConfigEnabled(
        getConfigValueProps,
        SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING
      );

      if (isSentralWellbeingEnabled) {
        return false;
      }

      const isBehaviourSetupCardEnabled = ACLStore.can(
        ENABLE_BEHAVIOUR_SETUP_CARD
      );

      if (isBehaviourSetupCardEnabled) {
        return false;
      }

      const isRnPConsumptionEnabled = ACLStore.can(
        ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION
      );
      const hasAdminPortalAccess = ACLStorage.getModuleSettingsValueByContext(
        ADMIN_PORTAL_ACCESS_PERMISSION,
        []
      );
      const isRnPEnabledInBehaviour =
        ACLStore.can(ENABLE_RNP_CONSUMPTION_IN_BEHAVIOUR) &&
        isRnPConsumptionEnabled;

      if (isRnPEnabledInBehaviour) {
        return (
          ACLStorage.getModuleSettingsValueByContext(
            BEHAVIOUR_DASHBOARD_ACCESS_PERMISSION,
            []
          ) && hasAdminPortalAccess
        );
      }

      if (isRnPConsumptionEnabled) {
        return hasAdminPortalAccess;
      }

      const perms = [
        ENABLE_BEHAVIOUR_MODULE_PERM,
        ENABLE_BEHAVIOUR_MODULE_IN_ADMIN_PORTAL,
      ];
      return _.some(perms, perm =>
        getConfigValue({ ...getConfigValueProps, configuration: perm })
      );
    },
    order: 13,
  },
  ADMIN_BEHAVIOUR_CONFIGURATION_MODULE: {
    id: "ADMIN_BEHAVIOUR_CONFIGURATION_MODULE",
    title: "behaviour:behaviour_management",
    subTitle: "common:admin_portal",
    searchText: ["behav", "manag", "well", "pasto"],
    perms: [
      ENABLE_BEHAVIOUR_MODULE_PERM,
      ENABLE_BEHAVIOUR_MODULE_IN_ADMIN_PORTAL,
      ENABLE_BEHAVIOUR_SETUP_CARD,
    ],
    customIsIncluded: getConfigValueProps => {
      const isSentralWellbeingEnabled = isSentralConfigEnabled(
        getConfigValueProps,
        SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING
      );

      if (isSentralWellbeingEnabled) {
        return false;
      }

      const isBehaviourSetupCardEnabled = ACLStore.can(
        ENABLE_BEHAVIOUR_SETUP_CARD
      );
      if (!isBehaviourSetupCardEnabled) {
        return false;
      }

      const isRnPConsumptionEnabled = ACLStore.can(
        ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION
      );
      const hasAdminPortalAccess = ACLStorage.getModuleSettingsValueByContext(
        ADMIN_PORTAL_ACCESS_PERMISSION,
        []
      );
      const isRnPEnabledInBehaviour =
        ACLStore.can(ENABLE_RNP_CONSUMPTION_IN_BEHAVIOUR) &&
        isRnPConsumptionEnabled;

      if (isRnPEnabledInBehaviour) {
        return (
          ACLStorage.getModuleSettingsValueByContext(
            BEHAVIOUR_SETUP_ACCESS_PERMISSION,
            []
          ) && hasAdminPortalAccess
        );
      }

      if (isRnPConsumptionEnabled) {
        return hasAdminPortalAccess;
      }

      const perms = [
        ENABLE_BEHAVIOUR_MODULE_PERM,
        ENABLE_BEHAVIOUR_MODULE_IN_ADMIN_PORTAL,
      ];

      return _.some(perms, perm =>
        getConfigValue({
          ...getConfigValueProps,
          configuration: perm,
        })
      );
    },
    order: 13,
  },
  ADMIN_ATTENDANCE_MODULE: {
    id: "ADMIN_ATTENDANCE_MODULE",
    title: "attendance:attendance_manager",
    subTitle: "common:admin_portal",
    searchText: ["atte", "abse", "pres"],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 11,
    customIsExcluded: getConfigValueProps => {
      const isSentralAttendanceEnabled = isSentralConfigEnabled(
        getConfigValueProps,
        SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE
      );

      if (isSentralAttendanceEnabled) {
        return true;
      }

      return !getConfigValue({
        ...getConfigValueProps,
        configuration: "Common:AttendanceDashboard",
      });
    },
  },
  ADMIN_REPORT_MODULE_PYP: {
    id: "ADMIN_REPORT_MODULE_PYP",
    title: "common:progress_reports",
    subTitle: "common:admin_portal",
    searchText: ["repo", "progr", "resu", "asse", "rate"],
    controlParameterConfig: PROGRESS_REPORTS_ADMIN_LEVEL_CONTROL_PARAMETER_CONFIG,
    curriculumPrograms: [CURRICULUM_TYPE_PYP],
    order: 12,
  },
  ADMIN_REPORT_MODULE_MYP: {
    id: "ADMIN_REPORT_MODULE_MYP",
    title: "common:progress_reports",
    subTitle: "common:admin_portal",
    searchText: ["repo", "progr", "resu", "asse", "rate"],
    controlParameterConfig: PROGRESS_REPORTS_ADMIN_LEVEL_CONTROL_PARAMETER_CONFIG,
    curriculumPrograms: [CURRICULUM_TYPE_MYP],
    order: 12,
  },
  ADMIN_REPORT_MODULE_UBD: {
    id: "ADMIN_REPORT_MODULE_UBD",
    title: "common:progress_reports",
    subTitle: "common:admin_portal",
    searchText: ["repo", "progr", "resu", "asse", "rate"],
    controlParameterConfig: PROGRESS_REPORTS_ADMIN_LEVEL_CONTROL_PARAMETER_CONFIG,
    curriculumPrograms: [CURRICULUM_TYPE_UBD],
    order: 12,
  },
  ADMIN_REPORT_MODULE_DP: {
    id: "ADMIN_REPORT_MODULE_DP",
    title: "common:progress_reports",
    subTitle: "common:admin_portal",
    searchText: ["repo", "progr", "resu", "asse", "rate"],
    controlParameterConfig: PROGRESS_REPORTS_ADMIN_LEVEL_CONTROL_PARAMETER_CONFIG,
    curriculumPrograms: [CURRICULUM_TYPE_DP],
    order: 12,
  },
  ADMIN_EDUCATION_CENTER_MODULE: {
    id: "ADMIN_EDUCATION_CENTER_MODULE",
    title: "teacherHomePage:educator_center",
    subTitle: "common:admin_portal",
    searchText: ["edu", "cent"],
    perms: ["AdminPortal"],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 15,
    customIsExcluded: () => {
      return isEducatorCenterRevampParentPermEnabled();
    },
  },
  ADMIN_SCHOOL_POLICIES_AND_RESOURCES_MODULE: {
    id: "ADMIN_SCHOOL_POLICIES_AND_RESOURCES_MODULE",
    title: "common:school_policies_and_resources",
    subTitle: "common:admin_portal",
    searchText: ["scho", "poli", "reso"],
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: VIEW_SCHOOL_POLICIES_AND_RESOURCES_MODULE_PERMISSION,
      contextType: "CURRICULUM_PROGRAM",
    },
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 15,
    customIsExcluded: getConfigValueProps => {
      const isSentralPoliciesEnabled = isSentralConfigEnabled(
        getConfigValueProps,
        SENTRAL_PERMISSION_CONFIGURATIONS.POLICIES_AND_RESOURCES
      );

      if (isSentralPoliciesEnabled) {
        return true;
      }
      return !isEducatorCenterRevampParentPermEnabled();
    },
  },
  ADMIN_SETTINGS_MODULE: {
    id: "ADMIN_SETTINGS_MODULE",
    title: "common:module_settings",
    subTitle: "common:admin_portal",
    searchText: ["set"],
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 17,
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: MODULE_SETTINGS_ACCESS_PERMISSION,
      contextType: "CURRICULUM_PROGRAM",
    },
  },
  ADMIN_AUTH_EVALUATION: {
    id: "ADMIN_AUTH_EVALUATION",
    title: "teacherHomePage:authorizationEvaluation",
    subTitle: "common:admin_portal",
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    order: 20,
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: SNPv2_ACCESS_PERMISSION,
      contextType: "CURRICULUM_PROGRAM", //contextType represents the type of context in which permission value will be evaluated.
    },
  },
  PLANNING_INSIGHTS_MODULE: {
    id: "PLANNING_INSIGHTS_MODULE",
    title: "common:insights",
    subTitle: "teacherHomePage:planning_insights",
    searchText: ["insi", "plan", "anal"],
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 31,
    perms: [GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.INSIGHTS_SEARCH],
  },
  CLASSROOM_MODULE: {
    id: "CLASSROOM_MODULE",
    title: "common:assignments",
    subTitle: "common:assignments",
    searchText: ["class", "assi", "stre", "work", "home", "disc", "zoo"],
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: ASSIGNMENTS_ACCESS_PERMISSION,
      contextType: "CURRICULUM_PROGRAM",
    },
    order: 21,
  },
  CONTINUUM_MODULE_PYP: {
    id: "CONTINUUM_MODULE_PYP",
    title: "teacherHomePage:continuum",
    subTitle: "teacherHomePage:continuum",
    searchText: ["con", "conti"],
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: CAN_VIEW_CONTINUUM_MODULE_SETTING,
      contextType: "CURRICULUM_PROGRAM",
    },
    curriculumPrograms: ["IB_PYP"],
    order: 22,
  },
  CLASS_SETTINGS_V2: {
    id: "CLASS_SETTINGS_V2",
    title: "common:class_settings",
    subTitle: "common:class_settings",
    searchText: [],
    isPath: true,
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: CLASS_SETTINGS_ACCESS_PERMISSION,
      contextType: "CURRICULUM_PROGRAM",
    },
    curriculumPrograms: ALL_CURRICULUM_PROGRAMS,
    path: [{ label: "text", value: "common:class_settings" }],
    order: 26,
  },
  CONTINUUM_MODULE_MYP: {
    id: "CONTINUUM_MODULE_MYP",
    title: "teacherHomePage:continuum",
    subTitle: "teacherHomePage:continuum",
    searchText: ["con", "conti"],
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: CAN_VIEW_CONTINUUM_MODULE_SETTING,
      contextType: "CURRICULUM_PROGRAM",
    },
    curriculumPrograms: ["IB_MYP"],
    order: 22,
  },
  CONTINUUM_MODULE_UBD: {
    id: "CONTINUUM_MODULE_UBD",
    title: "teacherHomePage:continuum",
    subTitle: "teacherHomePage:continuum",
    searchText: ["con", "conti"],
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: CAN_VIEW_CONTINUUM_MODULE_SETTING,
      contextType: "CURRICULUM_PROGRAM",
    },
    curriculumPrograms: ["UBD"],
    order: 22,
  },
  JOURNAL_MODULE: {
    id: "JOURNAL_MODULE",
    title: "teacherHomePage:portfolio",
    subTitle: "teacherHomePage:portfolio",
    searchText: ["jour", "portf", "clas", "post", "evid"],
    perms: ["Common:Portfolio"],
    order: 22,
    customIsExcluded: ({ subjectType, allowedSubjectTypes }) => {
      return (
        _.includes(["CAS", "TOK", "EE"], subjectType) &&
        !_.includes(allowedSubjectTypes, subjectType)
      );
    },
  },
  CALENDAR_MODULE: {
    id: "CALENDAR_MODULE",
    title: "common:calendar",
    subTitle: "common:calendar",
    searchText: ["cale", "sche", "call", "zoo", "disc"],
    controlParameterConfig: {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: CAN_VIEW_CALENDAR_MODULE_SETTING,
      contextType: "CURRICULUM_PROGRAM",
    },
    order: 25,
  },
  ATTENDANCE_MODULE: {
    id: "ATTENDANCE_MODULE",
    title: "common:attendance",
    subTitle: "common:attendance",
    searchText: ["atte", "roll", "call", "abs", "pres"],
    order: 24,
    customIsExcluded: getConfigValueProps => {
      const isSentralAttendanceEnabled = isSentralConfigEnabled(
        getConfigValueProps,
        SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE
      );

      if (isSentralAttendanceEnabled) {
        return true;
      }

      return !getConfigValue({
        ...getConfigValueProps,
        configuration: "TeacherPortal:Attendance",
      });
    },
  },
  REPORT_MODULE: {
    id: "REPORT_MODULE",
    title: "common:reports",
    subTitle: "teacherHomePage:progress_report",
    searchText: ["repo", "prog", "resu", "asse", "rate"],
    controlParameterConfig: PROGRESS_REPORTS_PROGRAMME_LEVEL_CONTROL_PARAMETER_CONFIG,
    order: 28,
    curriculumPrograms: [CURRICULUM_TYPE_PYP],
    perms: [GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.REPORTS_SEARCH],
  },
  TEACHER_RESOURCES_MODULE: {
    id: "TEACHER_RESOURCES_MODULE",
    title: "teacherHomePage:teacher_resources",
    subTitle: "teacherHomePage:teacher_resources",
    searchText: ["reso", "book", "poli", "docu", "guid"],
    perms: ["TeacherPortal:TeacherResources"],
    order: 33,
    customIsExcluded: () => {
      return isEducatorCenterRevampParentPermEnabled();
    },
  },
  UNIT_LIBRARY_MODULE: {
    id: "UNIT_LIBRARY_MODULE",
    title: "teacherHomePage:unit_library",
    subTitle: "teacherHomePage:unit_library",
    searchText: ["libr", "unit", "arch", "prev"],
    perms: ["TeacherPortal:UnitLibrary"],
    order: 34,
  },
  LE_LIBRARY_MODULE: {
    id: "LE_LIBRARY_MODULE",
    title: "common:learning_experience_library",
    subTitle: "common:learning_experience_library",
    perms: [
      "TeacherPortal:LELibrary",
      "TeacherPortal:LELibraryMyp",
      "TeacherPortal:LELibraryUbd",
    ],
    order: 35,
  },
  ASSES_LEARNING_MODULE: {
    id: "ASSES_LEARNING_MODULE",
    title: "teacherHomePage:assess_learning",
    subTitle: "teacherHomePage:assess_learning",
    searchText: ["as", "lear"],
    perms: ["TeacherPortal:AssessmentEvaluation"],
    order: 32,
  },
  TEACHER_POLICIES_MODULE: {
    id: "TEACHER_POLICIES_MODULE",
    title: "teacherHomePage:school_policy",
    subTitle: "teacherHomePage:school_policy",
    searchText: ["pol"],
    perms: ["TeacherPortal:TeacherSchoolPolicies"],
    order: 34,
    customIsExcluded: () => {
      return isEducatorCenterRevampParentPermEnabled();
    },
  },
  CLASS_SETTINGS_MODULE: {
    id: "CLASS_SETTINGS_MODULE",
    title: "common:class_settings",
    subTitle: "common:class_settings",
    permsCheckMode: "AND",
    perms: ["TeacherPortal:ClassSetting", "TeacherPortal:ShowOldClassSetting"],
    order: 34,
  },
  TEACHER_NOTIFICATION_PREFERENCES_MODULE: {
    id: "TEACHER_NOTIFICATION_PREFERENCES_MODULE",
    title: "configuration:notifications_preferences",
    subTitle: "configuration:notifications_preferences",
    searchText: ["not"],
    permsCheckMode: "AND",
    perms: [
      "Common:NotificationConfiguration",
      "TeacherPortal:ShowOldClassSetting",
    ],
    order: 36,
  },
  MANAGE_FAMILY_MODULE: {
    id: "MANAGE_FAMILY_MODULE",
    title: "common:manage_family_members",
    subTitle: "common:manage_family_members",
    searchText: ["fami"],
    permsCheckMode: "AND",
    perms: [
      "TeacherPortal:ManageFamilyMembers",
      "TeacherPortal:ShowOldClassSetting",
    ],
    order: 37,
  },
  ATL_MODULE: {
    id: "ATL_MODULE",
    title: "common:atls_label",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "common:atls_label" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    subTitle: "common:atls_label",
    searchText: ["atl"],
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    curriculumPrograms: ["IB_PYP"],
    order: 38,
  },
  CONCEPT_INSIGHT_MODULE: {
    id: "CONCEPT_INSIGHT_MODULE",
    title: "common:concept_plural",
    subTitle: "common:concept_plural",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "common:concept_plural" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    searchText: ["conc"],
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 38,
    curriculumPrograms: ["IB_PYP"],
  },
  THEME_DESCRIPTOR_MODULE: {
    id: "THEME_DESCRIPTOR_MODULE",
    title: "POI:theme_descriptors",
    subTitle: "POI:theme_descriptors",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "POI:theme_descriptors" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    searchText: ["theme"],
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 38,
    curriculumPrograms: ["IB_PYP"],
  },
  LPA_INSIGHT_MODULE: {
    id: "LPA_INSIGHT_MODULE",
    title: "common:lp_label",
    subTitle: "common:lp_label",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "common:lp_label" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    searchText: ["lear"],
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 38,
    curriculumPrograms: ["IB_PYP"],
  },
  SUBJECT_INSIGHT_MODULE: {
    id: "SUBJECT_INSIGHT_MODULE",
    title: "common:subject_plural",
    subTitle: "common:subject_plural",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "common:subject_plural" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    searchText: ["sub"],
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 38,
    curriculumPrograms: ["IB_PYP"],
  },
  POI_MODULE: {
    id: "POI_MODULE",
    title: "teacherHomePage:poi",
    subTitle: "teacherHomePage:poi",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "teacherHomePage:poi" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 39,
    curriculumPrograms: ["IB_PYP"],
  },
  SUBJECT_GROUP_OVERVIEW_MYP_INSIGHTS_MODULE: {
    id: "SUBJECT_GROUP_OVERVIEW_MYP_INSIGHTS_MODULE",
    title: "planningInsights:vertical_overview_subject_group_overview_label",
    subtitle: "planningInsights:vertical_overview_subject_group_overview_label",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      {
        label: "text",
        value:
          "planningInsights:vertical_overview_subject_group_overview_label",
      },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 40,
    curriculumPrograms: [CURRICULUM_TYPE_MYP],
    icon: SubjectOverviewDuotone,
  },
  POI_MYP_INSIGHTS_MODULE: {
    id: "POI_MYP_INSIGHTS_MODULE",
    title: "planningInsights:vertical_overview_programme_of_inquiry_label",
    subtitle: "planningInsights:vertical_overview_programme_of_inquiry_label",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      {
        label: "text",
        value: "planningInsights:vertical_overview_programme_of_inquiry_label",
      },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 40,
    curriculumPrograms: [CURRICULUM_TYPE_MYP],
    icon: ProgrammeofInquiryDuotone,
  },
  GLOBAL_CONTEXTS_MYP_INSIGHTS_MODULE: {
    id: "GLOBAL_CONTEXTS_MYP_INSIGHTS_MODULE",
    title: "planningInsights:vertical_overview_global_contexts_insights_label",
    subtitle:
      "planningInsights:vertical_overview_global_contexts_insights_label",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      {
        label: "text",
        value:
          "planningInsights:vertical_overview_global_contexts_insights_label",
      },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 41,
    curriculumPrograms: [CURRICULUM_TYPE_MYP],
    icon: GlobalContextDuotone,
  },
  KEY_AND_RELATED_CONCEPTS_MYP_INSIGHTS_MODULE: {
    id: "KEY_AND_RELATED_CONCEPTS_MYP_INSIGHTS_MODULE",
    title:
      "planningInsights:vertical_overview_key_and_related_concepts_insights_label",
    subtitle:
      "planningInsights:vertical_overview_key_and_related_concepts_insights_label",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      {
        label: "text",
        value:
          "planningInsights:vertical_overview_key_and_related_concepts_insights_label",
      },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 42,
    curriculumPrograms: [CURRICULUM_TYPE_MYP],
    icon: KeyRelatedConceptsDuotone,
  },
  ATL_MYP_INSIGHTS_MODULE: {
    id: "ATL_MYP_INSIGHTS_MODULE",
    title: "planningInsights:vertical_overview_approaches_to_learning_label",
    subtitle: "planningInsights:vertical_overview_approaches_to_learning_label",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      {
        label: "text",
        value:
          "planningInsights:vertical_overview_approaches_to_learning_label",
      },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 43,
    curriculumPrograms: [CURRICULUM_TYPE_MYP],
    icon: AtlDuotone,
  },
  OBJECTIVES_MYP_INSIGHTS_MODULE: {
    id: "OBJECTIVES_MYP_INSIGHTS_MODULE",
    title: "planningInsights:vertical_overview_MYP_objectives_insights_label",
    subtitle:
      "planningInsights:vertical_overview_MYP_objectives_insights_label",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      {
        label: "text",
        value:
          "planningInsights:vertical_overview_MYP_objectives_insights_label",
      },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 44,
    curriculumPrograms: [CURRICULUM_TYPE_MYP],
    icon: ObjectivesDuotone,
  },
  SUBJECT_STANDARDS_MYP_INSIGHTS_MODULE: {
    id: "SUBJECT_STANDARDS_MYP_INSIGHTS_MODULE",
    title: "common:subject_standards",
    subtitle: "common:subject_standards",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "common:subject_standards" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 45,
    curriculumPrograms: [CURRICULUM_TYPE_MYP],
    icon: SubjectGenericDuotone,
  },
  LPA_MYP_INSIGHTS_MODULE: {
    id: "LPA_MYP_INSIGHTS_MODULE",
    title: "planningInsights:lpa",
    subtitle: "planningInsights:lpa",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "planningInsights:lpa" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 46,
    curriculumPrograms: [CURRICULUM_TYPE_MYP],
    icon: LearnerProfileDuotone,
  },
  SUBJECT_GROUP_TIMELINE_MYP_INSIGHTS_MODULE: {
    id: "SUBJECT_GROUP_TIMELINE_MYP_INSIGHTS_MODULE",
    title: "planningInsights:subject_group_timeline_view",
    subtitle: "planningInsights:subject_group_timeline_view",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "planningInsights:subject_group_timeline_view" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 47,
    curriculumPrograms: [CURRICULUM_TYPE_MYP],
    icon: TimelineDuotone,
  },
  UNITS_TIMELINE_VIEW_UBD_INSIGHTS_MODULE: {
    id: "UNITS_TIMELINE_VIEW_UBD_INSIGHTS_MODULE",
    title: "common:units_timeline_view",
    subtitle: "common:units_timeline_view",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "common:units_timeline_view" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 40,
    curriculumPrograms: [CURRICULUM_TYPE_UBD],
    icon: TimelineDuotone,
  },
  SKILLS_UBD_INSIGHTS_MODULE: {
    id: "SKILLS_UBD_INSIGHTS_MODULE",
    title: "common:skill_plural",
    subtitle: "common:skill_plural",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "common:skill_plural" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 41,
    curriculumPrograms: [CURRICULUM_TYPE_UBD],
    icon: AtlDuotone,
  },
  SYLLABUS_CONTENT_DP_INSIGHTS_MODULE: {
    id: "SYLLABUS_CONTENT_DP_INSIGHTS_MODULE",
    title: "common:syllabus_content_label",
    subtitle: "common:syllabus_content_label",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "common:syllabus_content_label" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 40,
    curriculumPrograms: [CURRICULUM_TYPE_DP],
    skipForSubjectGroup: ["CORE", "OTHERS"],
    icon: OpenBookDuotone,
  },
  SYLLABUS_OUTLINE_DP_INSIGHTS_MODULE: {
    id: "SYLLABUS_OUTLINE_DP_INSIGHTS_MODULE",
    title: "unitPlan:syllabus_outline",
    subtitle: "unitPlan:syllabus_outline",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "unitPlan:syllabus_outline" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 41,
    curriculumPrograms: [CURRICULUM_TYPE_DP],
    skipForSubjectGroup: ["GENERIC", "OTHERS", "CP_CORE"],
    icon: SummativeAssessmentDuotone,
  },
  AIMS_DP_INSIGHTS_MODULE: {
    id: "AIMS_DP_INSIGHTS_MODULE",
    title: "common:aim_label",
    subtitle: "common:aim_label",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "common:aim_label" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 42,
    curriculumPrograms: [CURRICULUM_TYPE_DP],
    skipForSubjectGroup: ["OTHERS"],
    icon: ObjectivesDuotone,
  },
  ASSESSMENT_OBJECTIVES_DP_INSIGHTS_MODULE: {
    id: "ASSESSMENT_OBJECTIVES_DP_INSIGHTS_MODULE",
    title: "common:objectives_label",
    subtitle: "common:objectives_label",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "common:objectives_label" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 43,
    curriculumPrograms: [CURRICULUM_TYPE_DP],
    skipForSubjectGroup: ["OTHERS", "CP_CORE"],
    icon: AssessmentsDuotone,
  },
  CONNECTIONS_DP_INSIGHTS_MODULE: {
    id: "CONNECTIONS_DP_INSIGHTS_MODULE",
    title: "planningInsights:connections",
    subtitle: "planningInsights:connections",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "planningInsights:connections" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 44,
    curriculumPrograms: [CURRICULUM_TYPE_DP],
    icon: DifferentiationDuotone,
  },
  SUBJECT_STANDARDS_DP_INSIGHTS_MODULE: {
    id: "SUBJECT_STANDARDS_DP_INSIGHTS_MODULE",
    title: "common:subject_standards",
    subtitle: "common:subject_standards",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "common:subject_standards" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 45,
    curriculumPrograms: [CURRICULUM_TYPE_DP],
    skipForSubjectGroup: CORE_TYPES,
    icon: LearningStandardsDuotone,
  },
  LPA_DP_INSIGHTS_MODULE: {
    id: "LPA_DP_INSIGHTS_MODULE",
    title: "planningInsights:lpa",
    subtitle: "planningInsights:lpa",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "planningInsights:lpa" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 46,
    curriculumPrograms: [CURRICULUM_TYPE_DP],
    icon: LearnerProfileDuotone,
  },
  BENCHMARKS_DP_INSIGHTS_MODULE: {
    id: "BENCHMARKS_DP_INSIGHTS_MODULE",
    title: "common:benchmarks_label",
    subtitle: "common:benchmarks_label",
    isPath: true,
    path: [
      { label: "text", value: "teacherHomePage:planning_insights" },
      { label: "text", value: "common:benchmarks_label" },
    ],
    getCustomPath: getInsightsBasedModulesPath,
    controlParameterConfig: PLANNING_INSIGHTS_CONTROL_PARAMETER_CONFIG,
    order: 47,
    curriculumPrograms: [CURRICULUM_TYPE_DP],
    skipForSubjectGroup: ["CORE", "OTHERS", "GENERIC", "TOK"],
    skipForSubjectType: ["LD", "SLR", "CE", "RP"],
    icon: LeAndTeachingStrategiesDuotone,
  },
  ALL_STUDENT_ASSIGNMENT_SUBMISSION: {
    id: "ALL_STUDENT_ASSIGNMENT_SUBMISSION",
    title: "",
    subTitle: "",
    isPath: true,
    path: [
      { label: "variable", value: "courseName" },
      { label: "text", value: "common:assignments" },
    ],
    searchText: [],
    perms: [],
    order: 54,
  },
  STUDENT_ASSIGNMENT_SUBMISSION: {
    id: "STUDENT_ASSIGNMENT_SUBMISSION",
    title: "",
    subTitle: "",
    isPath: true,
    path: [
      { label: "variable", value: "courseName" },
      { label: "text", value: "common:assignments" },
    ],
    searchText: [],
    perms: [],
    order: 54,
  },
  MODULES: {
    id: "MODULES",
    title: "common:modules",
    subTitle: "common:modules",
    searchText: [],
    perms: [GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.MODULES_SEARCH],
  },
  GLOBAL_SEARCH_AND_JUMP_TO_MODULES: {
    id: "GLOBAL_SEARCH_AND_JUMP_TO_MODULES",
    perms: [
      "Common:PersonalProject",
      "Common:CommunityProject",
      "Common:ServiceAsAction",
      "Common:EEProjects",
      "Common:CASPortfolio",
      "Common:TOKEssayProjects",
      "Common:TOKExhibitionProjects",
      "Common:Group4AndCollaborativeSciences",
      "Common:ReflectiveProject",
      "Common:ServiceLearning",
      "TeacherPortal:AttendanceDashboard",
      "Common:AttendanceDashboard",
      "Common:Announcement",
      "Common:Classroom",
      "Common:PlatformCalendar",
      TODDLE_2_O_PERMISSION,
      "TeacherPortal:FamilyCommunications",
      "Common:LearnerPortfolio",
      "Common:EducatorCenterRevamp",
      "Common:StudentGoals",
      "Common:Homeroom",
      "FeatureFlag:SubjectCenter",
      "FeatureFlag:BehaviourManagement",
      ENABLE_RNP_CONSUMPTION_IN_BEHAVIOUR,
      "FeatureFlag:EnableGlobalHeaderOnMultipleScreens",
      SCHOOL_LIBRARY_PERM,
      "TeacherPortal:EducationCenter",
      "TeacherPortal:ContentSkills",
      "TeacherPortal:ManageSchools",
      "TeacherPortal:ManageUnitPublish",
      "TeacherPortal:DPProgressReports",
      "TeacherPortal:MYPProgressReports",
      "TeacherPortal:UBDProgressReports",
      SNPv2_PERM,
      SNPv2_TEACHER_MODULE_PERM,
      "FeatureFlag:EnableGlobalHeader",
      "FeatureFlag:BehaviourAdminPortal",
      "Common:AssignmentsManager",
      TODDLE_ANALYTICS_USER_BASED_ACCESS_PERM,
      TODDLE_ANALYTICS_PERMISSION,
      ENGAGEMENT_ANALYTICS_PERMISSION,
      PERFORMANCE_ANALYTICS_PERMISSION,
      MODULE_USAGE_ANALYTICS_PERMISSION,
      BEHAVIOUR_ANALYTICS_PERMISSION,
      ATTENDANCE_ANALYTICS_PERMISSION,
      SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE,
      SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING,
      SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
      SENTRAL_PERMISSION_CONFIGURATIONS.POLICIES_AND_RESOURCES,
      LEARNING_COURSE_PERM,
      SENTRAL_PERMISSION_CONFIGURATIONS.NOTICE,
      SENTRAL_PERMISSION_CONFIGURATIONS.NEWSFEED,
      SENTRAL_PERMISSION_CONFIGURATIONS.PXP,
    ],
  },
};

export const typesModulesList = [
  typesConfig.IB_PYP.id,
  typesConfig.IB_MYP.id,
  typesConfig.UBD.id,
  typesConfig.IB_DP.id,
  typesConfig.HOME_SCHOOL_LIBRARY_MODULE.id,
  typesConfig.HOME_ANNOUNCEMENT_MODULE.id,
  typesConfig.HOME_PROGRESS_REPORTS_MODULE_UBD.id,
  typesConfig.HOME_PROGRESS_REPORTS_MODULE_MYP.id,
  typesConfig.HOME_PROGRESS_REPORTS_MODULE_DP.id,
  typesConfig.HOME_BEHAVIOUR_MANAGEMENT_MODULE.id,
  typesConfig.HOME_SCHOOL_POLICIES_AND_RESOURCES_MODULE.id,
  typesConfig.HOME_ATTENDANCE_MODULE.id,
  typesConfig.HOME_HOMEROOM_MODULE.id,
  typesConfig.HOME_CLASSROOM_MODULE.id,
  typesConfig.HOME_CALENDAR_MODULE.id,
  typesConfig.HOME_MESSAGING_MODULE.id,
  typesConfig.HOME_FAMILY_MESSAGING_MODULE.id,
  typesConfig.HOME_STUDENT_GOALS_MODULE.id,
  typesConfig.HOME_AUTH_EVALUATION.id,
  typesConfig.ADMIN_PANEL_MODULE.id,
  typesConfig.ADMIN_SCHOOL_SETUP_MODULE.id,
  typesConfig.ADMIN_TRANSCRIPTS_MODULE.id,
  typesConfig.ADMIN_INTEGRATIONS_MODULE.id,
  typesConfig.ADMIN_ACADEMY_ANALYTICS_MODULE.id,
  typesConfig.ADMIN_IBIS_REGISTRATION_MODULE.id,
  typesConfig.ADMIN_IB_E_COURSEWORK_MODULE.id,
  typesConfig.ADMIN_GRADEBOOK_MODULE.id,
  typesConfig.ADMIN_STAFF_ACCESS_PERMISSION_MODULE.id,
  typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_PYP.id,
  typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_MYP.id,
  typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_UBD.id,
  typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_DP.id,
  typesConfig.ADMIN_TIMETABLE_MODULE.id,
  typesConfig.ADMIN_PLANNING_INSIGHTS_MODULE.id,
  typesConfig.ADMIN_PLANNING_INSIGHTS_MODULE_DP.id,
  typesConfig.ADMIN_BIN_MODULE.id,
  typesConfig.ADMIN_ANNOUNCEMENT_MODULE.id,
  typesConfig.ADMIN_MESSAGING_MODULE.id,
  typesConfig.ADMIN_BEHAVIOUR_MANAGEMENT_MODULE.id,
  typesConfig.ADMIN_BEHAVIOUR_CONFIGURATION_MODULE.id,
  typesConfig.ADMIN_ATTENDANCE_MODULE.id,
  typesConfig.ADMIN_REPORT_MODULE_PYP.id,
  typesConfig.ADMIN_REPORT_MODULE_MYP.id,
  typesConfig.ADMIN_REPORT_MODULE_UBD.id,
  typesConfig.ADMIN_REPORT_MODULE_DP.id,
  typesConfig.ADMIN_EDUCATION_CENTER_MODULE.id,
  typesConfig.ADMIN_SCHOOL_POLICIES_AND_RESOURCES_MODULE.id,
  typesConfig.ADMIN_SETTINGS_MODULE.id,
  typesConfig.ADMIN_AUTH_EVALUATION.id,
  typesConfig.ESF_SENTRAL_WELLBEING.id,
  typesConfig.ESF_SENTRAL_ATTENDANCE.id,
  typesConfig.ESF_SENTRAL_POLICIES.id,
  typesConfig.ESF_SENTRAL_TIMETABLE.id,
  typesConfig.ESF_SENTRAL_PXP.id,
  typesConfig.ESF_SENTRAL_NEWSFEED.id,
  typesConfig.ESF_SENTRAL_DAILY_NOTICE.id,
];

export const modulesAsFiltersList = [
  typesConfig.MODULES.id,
  typesConfig.UNIT_PLAN.id,
  typesConfig.STUDENT_PROFILE.id,
  typesConfig.LE.id,
  typesConfig.REPORT_MODULE.id,
];

export const modulesAsFiltersListV2 = [
  typesConfig.UNIT_PLAN.id,
  typesConfig.LE.id,
  typesConfig.COURSE.id,
  typesConfig.LEARNING_COURSE.id,
  typesConfig.STUDENT_PROFILE.id,
  typesConfig.TEACHER_PROFILE.id,
  typesConfig.FAMILY_PROFILE.id,
  typesConfig.REPORT_MODULE.id,
  typesConfig.PLANNING_INSIGHTS_MODULE.id,
];

export const modulesAsFiltersListV3 = [
  typesConfig.MODULES.id,
  ...modulesAsFiltersListV2,
];

const pypInsightModules = [
  typesConfig.ATL_MODULE.id,
  typesConfig.CONCEPT_INSIGHT_MODULE.id,
  typesConfig.THEME_DESCRIPTOR_MODULE.id,
  typesConfig.LPA_INSIGHT_MODULE.id,
  typesConfig.SUBJECT_INSIGHT_MODULE.id,
  typesConfig.POI_MODULE.id,
];

const mypInsightModules = [
  typesConfig.SUBJECT_GROUP_OVERVIEW_MYP_INSIGHTS_MODULE.id,
  typesConfig.POI_MYP_INSIGHTS_MODULE.id,
  typesConfig.GLOBAL_CONTEXTS_MYP_INSIGHTS_MODULE.id,
  typesConfig.KEY_AND_RELATED_CONCEPTS_MYP_INSIGHTS_MODULE.id,
  typesConfig.ATL_MYP_INSIGHTS_MODULE.id,
  typesConfig.OBJECTIVES_MYP_INSIGHTS_MODULE.id,
  typesConfig.SUBJECT_STANDARDS_MYP_INSIGHTS_MODULE.id,
  typesConfig.LPA_MYP_INSIGHTS_MODULE.id,
  typesConfig.SUBJECT_GROUP_TIMELINE_MYP_INSIGHTS_MODULE.id,
];

const ubdInsightModules = [
  typesConfig.UNITS_TIMELINE_VIEW_UBD_INSIGHTS_MODULE.id,
  typesConfig.SKILLS_UBD_INSIGHTS_MODULE.id,
];

const dpInsightModules = [
  typesConfig.SYLLABUS_CONTENT_DP_INSIGHTS_MODULE.id,
  typesConfig.SYLLABUS_OUTLINE_DP_INSIGHTS_MODULE.id,
  typesConfig.AIMS_DP_INSIGHTS_MODULE.id,
  typesConfig.ASSESSMENT_OBJECTIVES_DP_INSIGHTS_MODULE.id,
  typesConfig.CONNECTIONS_DP_INSIGHTS_MODULE.id,
  typesConfig.SUBJECT_STANDARDS_DP_INSIGHTS_MODULE.id,
  typesConfig.LPA_DP_INSIGHTS_MODULE.id,
  typesConfig.BENCHMARKS_DP_INSIGHTS_MODULE.id,
];

export const insightsBasedModules = [
  ...pypInsightModules,
  ...mypInsightModules,
  ...ubdInsightModules,
  ...dpInsightModules,
];

export const getCourseBasedModulesList = () => {
  return [
    typesConfig.COURSE.id,
    typesConfig.LEARNING_COURSE.id,
    ...(getIsInsightsSearchV2Enabled()
      ? []
      : [typesConfig.PLANNING_INSIGHTS_MODULE.id]),
    typesConfig.CLASSROOM_MODULE.id,
    typesConfig.JOURNAL_MODULE.id,
    typesConfig.CONTINUUM_MODULE_PYP.id,
    typesConfig.CONTINUUM_MODULE_MYP.id,
    typesConfig.CONTINUUM_MODULE_UBD.id,
    typesConfig.CLASS_SETTINGS_V2.id,
    typesConfig.CALENDAR_MODULE.id,
    typesConfig.ATTENDANCE_MODULE.id,
    // TODO: Remove this flag check once enabled for all
    ...(getProgressReportSearchV2Enabled()
      ? []
      : [typesConfig.REPORT_MODULE.id]),
    typesConfig.TEACHER_RESOURCES_MODULE.id,
    typesConfig.UNIT_LIBRARY_MODULE.id,
    typesConfig.LE_LIBRARY_MODULE.id,
    typesConfig.ASSES_LEARNING_MODULE.id,
    typesConfig.TEACHER_POLICIES_MODULE.id,
    typesConfig.TEACHER_NOTIFICATION_PREFERENCES_MODULE.id,
    typesConfig.MANAGE_FAMILY_MODULE.id,
    typesConfig.CLASS_SETTINGS_MODULE.id,
    ...(getIsInsightsSearchV2Enabled() ? [] : insightsBasedModules),
  ];
};

export const adminBasedModules = [
  typesConfig.ADMIN_PANEL_MODULE.id,
  typesConfig.ADMIN_SCHOOL_SETUP_MODULE.id,
  typesConfig.ADMIN_TRANSCRIPTS_MODULE.id,
  typesConfig.ADMIN_INTEGRATIONS_MODULE.id,
  typesConfig.ADMIN_ACADEMY_ANALYTICS_MODULE.id,
  typesConfig.ADMIN_IBIS_REGISTRATION_MODULE.id,
  typesConfig.ADMIN_IB_E_COURSEWORK_MODULE.id,
  typesConfig.ADMIN_GRADEBOOK_MODULE.id,
  typesConfig.ADMIN_STAFF_ACCESS_PERMISSION_MODULE.id,
  typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_PYP.id,
  typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_MYP.id,
  typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_UBD.id,
  typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_DP.id,
  typesConfig.ADMIN_TIMETABLE_MODULE.id,
  typesConfig.ADMIN_PLANNING_INSIGHTS_MODULE.id,
  typesConfig.ADMIN_PLANNING_INSIGHTS_MODULE_DP.id,
  typesConfig.ADMIN_BIN_MODULE.id,
  typesConfig.ADMIN_ANNOUNCEMENT_MODULE.id,
  typesConfig.ADMIN_MESSAGING_MODULE.id,
  typesConfig.ADMIN_BEHAVIOUR_MANAGEMENT_MODULE.id,
  typesConfig.ADMIN_BEHAVIOUR_CONFIGURATION_MODULE.id,
  typesConfig.ADMIN_ATTENDANCE_MODULE.id,
  typesConfig.ADMIN_REPORT_MODULE_PYP.id,
  typesConfig.ADMIN_REPORT_MODULE_MYP.id,
  typesConfig.ADMIN_REPORT_MODULE_UBD.id,
  typesConfig.ADMIN_REPORT_MODULE_DP.id,
  typesConfig.ADMIN_EDUCATION_CENTER_MODULE.id,
  typesConfig.ADMIN_SCHOOL_POLICIES_AND_RESOURCES_MODULE.id,
  typesConfig.ADMIN_SETTINGS_MODULE.id,
  typesConfig.ADMIN_AUTH_EVALUATION.id,
];

const ADMIN_MODULES_MOVED_TO_HOME_PAGE = [
  typesConfig.HOME_PLANNING_INSIGHTS_MODULE.id,
  typesConfig.HOME_PLANNING_INSIGHTS_MODULE_DP.id,
  typesConfig.HOME_GRADEBOOK_MODULE.id,
];

export const homeBasedModules = [
  typesConfig.HOME_SCHOOL_LIBRARY_MODULE.id,
  typesConfig.HOME_ANNOUNCEMENT_MODULE.id,
  typesConfig.HOME_PROGRESS_REPORTS_MODULE_UBD.id,
  typesConfig.HOME_PROGRESS_REPORTS_MODULE_MYP.id,
  typesConfig.HOME_PROGRESS_REPORTS_MODULE_DP.id,
  typesConfig.HOME_BEHAVIOUR_MANAGEMENT_MODULE.id,
  typesConfig.HOME_SCHOOL_POLICIES_AND_RESOURCES_MODULE.id,
  typesConfig.HOME_ATTENDANCE_MODULE.id,
  typesConfig.HOME_HOMEROOM_MODULE.id,
  typesConfig.HOME_CLASSROOM_MODULE.id,
  typesConfig.HOME_CALENDAR_MODULE.id,
  typesConfig.HOME_MESSAGING_MODULE.id,
  typesConfig.HOME_FAMILY_MESSAGING_MODULE.id,
  typesConfig.HOME_STUDENT_GOALS_MODULE.id,
  typesConfig.HOME_AUTH_EVALUATION.id,
  typesConfig.ESF_SENTRAL_WELLBEING.id,
  typesConfig.ESF_SENTRAL_ATTENDANCE.id,
  typesConfig.ESF_SENTRAL_POLICIES.id,
  typesConfig.ESF_SENTRAL_TIMETABLE.id,
  typesConfig.ESF_SENTRAL_PXP.id,
  typesConfig.ESF_SENTRAL_NEWSFEED.id,
  typesConfig.ESF_SENTRAL_DAILY_NOTICE.id,
];

export const homeBasedModulesShortcutMapping = {
  [typesConfig.HOME_SCHOOL_LIBRARY_MODULE.id]: HOME_PAGE_FEATURE_SCHOOL_LIBRARY,
  [typesConfig.HOME_ANNOUNCEMENT_MODULE.id]: HOME_PAGE_FEATURE_ANNOUNCEMENT,
  [typesConfig.HOME_PROGRESS_REPORTS_MODULE_UBD
    .id]: HOME_PAGE_FEATURE_PROGRESS_REPORT,
  [typesConfig.HOME_PROGRESS_REPORTS_MODULE_MYP
    .id]: HOME_PAGE_FEATURE_PROGRESS_REPORT,
  [typesConfig.HOME_PROGRESS_REPORTS_MODULE_DP
    .id]: HOME_PAGE_FEATURE_PROGRESS_REPORT,
  [typesConfig.HOME_BEHAVIOUR_MANAGEMENT_MODULE
    .id]: HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT,
  [typesConfig.HOME_SCHOOL_POLICIES_AND_RESOURCES_MODULE
    .id]: HOME_PAGE_FEATURE_EDUCATOR_CENTER,
  [typesConfig.HOME_ATTENDANCE_MODULE.id]: HOME_PAGE_FEATURE_ATTENDANCE,
  [typesConfig.HOME_HOMEROOM_MODULE.id]: HOME_PAGE_FEATURE_HOMEROOM,
  [typesConfig.HOME_CLASSROOM_MODULE.id]: HOME_PAGE_FEATURE_CLASSROOM_TODO,
  [typesConfig.HOME_CALENDAR_MODULE.id]: HOME_PAGE_FEATURE_CALENDAR,
  [typesConfig.HOME_MESSAGING_MODULE.id]: HOME_PAGE_FEATURE_MESSAGING,
  [typesConfig.HOME_FAMILY_MESSAGING_MODULE
    .id]: HOME_PAGE_FEATURE_FAMILY_COMMUNICATION,
  [typesConfig.HOME_AUTH_EVALUATION.id]: HOME_PAGE_FEATURE_SNP,
  [typesConfig.HOME_STUDENT_GOALS_MODULE.id]: HOME_PAGE_FEATURE_GOALS,
  [typesConfig.ESF_SENTRAL_WELLBEING.id]: ESF_SENTRAL_WELLBEING,
  [typesConfig.ESF_SENTRAL_ATTENDANCE.id]: ESF_SENTRAL_ATTENDANCE,
  [typesConfig.ESF_SENTRAL_POLICIES.id]: ESF_SENTRAL_POLICIES,
  [typesConfig.ESF_SENTRAL_TIMETABLE.id]: ESF_SENTRAL_TIMETABLE,
  [typesConfig.ESF_SENTRAL_PXP.id]: ESF_SENTRAL_PXP,
  [typesConfig.ESF_SENTRAL_NEWSFEED.id]: ESF_SENTRAL_NEWSFEED,
  [typesConfig.ESF_SENTRAL_DAILY_NOTICE.id]: ESF_SENTRAL_DAILY_NOTICE,
};

export const adminBasedModulesShortcutMapping = {
  [typesConfig.ADMIN_ANNOUNCEMENT_MODULE.id]: HOME_PAGE_FEATURE_ANNOUNCEMENT,
  [typesConfig.ADMIN_MESSAGING_MODULE.id]: HOME_PAGE_FEATURE_MESSAGING,
  [typesConfig.ADMIN_BEHAVIOUR_MANAGEMENT_MODULE
    .id]: HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT,
  [typesConfig.ADMIN_BEHAVIOUR_CONFIGURATION_MODULE
    .id]: HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT,
  [typesConfig.ADMIN_EDUCATION_CENTER_MODULE
    .id]: HOME_PAGE_FEATURE_EDUCATOR_CENTER,
  [typesConfig.ADMIN_SCHOOL_POLICIES_AND_RESOURCES_MODULE
    .id]: HOME_PAGE_FEATURE_EDUCATOR_CENTER,
  [typesConfig.ADMIN_AUTH_EVALUATION.id]: HOME_PAGE_FEATURE_SNP,
};

export const tasksBasedModules = [
  typesConfig.LE.id,
  typesConfig.ALL_STUDENT_ASSIGNMENT_SUBMISSION.id,
  typesConfig.STUDENT_ASSIGNMENT_SUBMISSION.id,
];

export const projectGroupBasedModules = [
  PROJECT_GROUP_TYPE_DP_CAS,
  PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
  PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
  PROJECT_GROUP_TYPE_DP_EE,
  PROJECT_GROUP_TYPE_PERSONAL,
  PROJECT_GROUP_TYPE_COMMUNITY,
  PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
  PROJECT_GROUP_TYPE_DP_G4_PROJECT,
  PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
  PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
  PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
  PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
];

const CURRICULUM_PROGRAMME = [
  typesConfig.IB_PYP.id,
  typesConfig.IB_MYP.id,
  typesConfig.UBD.id,
  typesConfig.IB_DP.id,
];

const HOME_ROOT_ROUTES = [
  ...CURRICULUM_PROGRAMME,
  typesConfig.ADMIN_PANEL_MODULE.id,
];

export const MODULE_FOR_SORT_OVERRIDE = [...CURRICULUM_PROGRAMME];
/**
 * Utils functions
 */

export const getOrgCurriculums = () => {
  const { org_id: orgId } = getUserInfo();

  const curriculumProgramsObj = getOrganizationCurriculumProgramsFromCache(
    orgId
  );

  const curriculumPrograms = _.get(
    curriculumProgramsObj,
    "curriculumPrograms",
    []
  );
  return curriculumPrograms;
};

export const checkForExcludedCurriculum = ({
  selectedCurriculumProgramTypes,
  type,
}) => {
  const { excludedCurriculumPrograms = [] } = typesConfig[type] ?? {};

  if (_.isEmpty(excludedCurriculumPrograms)) {
    return true;
  }

  const uniqueCurriculumTypes = _.uniq(selectedCurriculumProgramTypes);
  return _.some(
    uniqueCurriculumTypes,
    type => !excludedCurriculumPrograms.includes(type)
  );
};

export const checkIsModuleEnabled = ({
  type,
  course,
  curriculumProgram,
  userInfo,
}) => {
  if (!typesConfig[type]) {
    return false;
  }

  const {
    perms = [],
    permsCheckMode = "OR",
    customIsExcluded,
    controlParameterConfig,
    customIsIncluded,
  } = typesConfig[type];

  const { type: subjectType } = _.get(course, ["subjects", "0"], {});

  const { id: courseId } = course ?? {};
  const { id: curriculumProgramId, type: curriculumProgramType } =
    curriculumProgram ?? {};
  const {
    org_id: organizationId,
    id: userId,
    identityId,
    role,
    user_type: userType,
  } = userInfo ?? getUserInfo(); // to avoid computing getUserInfo multiple times when generating course based modules

  const allowedSubjectTypes = getSettingValue({
    name: "EnablePortfolioForDpCoreChild",
    currentCurriculumProgramId: curriculumProgramId,
  });

  const orgCurriculumPrograms = getOrgCurriculums();

  const userCurriculumPrograms = _.get(userInfo, "userCurriculumPrograms", []);
  const userCurriculumProgramsIds = _.map(userCurriculumPrograms, "id");

  const getConfigValueProps = {
    courseId,
    curriculumProgramId,
    userId,
    organizationId,
    identityId,
    role,
    userType,
    curriculumProgramType,
    orgCurriculumPrograms,
    subjectType,
    allowedSubjectTypes,
    userCurriculumProgramsIds,
  };

  if (customIsIncluded) {
    return customIsIncluded(getConfigValueProps);
  }

  if (customIsExcluded && customIsExcluded(getConfigValueProps)) {
    return false;
  }

  if (_.isUndefined(controlParameterConfig)) {
    if (!perms || perms.length === 0) {
      return true;
    }

    const getConfigurationValue = configuration => {
      const value = getConfigValue({
        ...getConfigValueProps,
        configuration,
      });
      return value;
    };

    if (permsCheckMode === "AND") {
      return _.every(perms, getConfigurationValue);
    } else {
      return _.some(perms, getConfigurationValue);
    }
  }

  const {
    controlParameter,
    //For global search, for each permission's value evaluation, context must be specified.
    //So, we are taking default value of ORGANIZATION for every permission's value evaluation.
    contextType = "ORGANIZATION",
    controlParameterType,
  } = controlParameterConfig;

  switch (controlParameterType) {
    case "MODULE_SETTINGS": {
      if (curriculumProgramId === "ALL") {
        return checkIfPermissionIsEnabledInAnyCurriculum({
          permission: controlParameter,
          curriculumProgramIds: userCurriculumProgramsIds,
        });
      }
      return ACLStorage.getModuleSettingsValueByContext(
        controlParameter,
        _getContextsFromContextType({
          contextType,
          curriculumProgramId,
        })
      );
    }
    default: {
      return ACLStorage.getPermissionValueByContext(
        controlParameter,
        _getContextsFromContextType({
          contextType,
          curriculumProgramId,
        })
      );
    }
  }
};

const _getContextsFromContextType = ({ contextType, curriculumProgramId }) => {
  switch (contextType) {
    case "CURRICULUM_PROGRAM": {
      const contexts = generateRnPContextsByLevel({
        level: "CURRICULUM_PROGRAM",
        curriculumProgramId,
      });

      return _.first(contexts);
    }
    default: {
      return [];
    }
  }
};

const getModuleItemTitle = ({
  t,
  type,
  curriculumProgram,
  shouldAddSuffix,
}) => {
  const isCurriculumHomeModule = _.includes(CURRICULUM_PROGRAMME, type);
  const { title } = typesConfig[type];

  if (
    _.includes(
      [
        typesConfig.HOME_BEHAVIOUR_MANAGEMENT_MODULE.id,
        typesConfig.ADMIN_BEHAVIOUR_MANAGEMENT_MODULE.id,
      ],
      type
    )
  ) {
    const organizationId = getOrganizationId();
    const behaviourNomenclatureConstants = getBehaviourNomenclatureFromCache({
      organizationId,
    });
    return behaviourNomenclatureConstants?.MODULE || t(title);
  }

  if (_.includes([typesConfig.ADMIN_BEHAVIOUR_CONFIGURATION_MODULE.id], type)) {
    const organizationId = getOrganizationId();
    const behaviourNomenclatureConstants = getBehaviourNomenclatureFromCache({
      organizationId,
    });
    return t("common:setup_with_label", {
      label: behaviourNomenclatureConstants?.MODULE,
    });
  }

  if (
    _.includes(
      [
        typesConfig.HOME_AUTH_EVALUATION.id,
        typesConfig.ADMIN_AUTH_EVALUATION.id,
      ],
      type
    )
  ) {
    const organizationId = getOrganizationId();
    const snpModuleLabelSetting = getSettingValue({
      organizationId,
      name: "AppSettingSnpModuleLabel",
    });

    return !_.isEmpty(snpModuleLabelSetting)
      ? t(`snp:${snpModuleLabelSetting}`, {
          defaultValue: snpModuleLabelSetting,
        })
      : t(title);
  }

  const { label: programLabel = "", acronym = "" } = curriculumProgram || {};

  if (!isCurriculumHomeModule) {
    return t(title);
    // return shouldAddSuffix ? `${t(title)} - ${acronym}` : t(title);
  }

  if (isCurriculumHomeModule) {
    return `${programLabel} (${acronym})`;
  }
};

/**
 * @description A lowest level Single Responsibility Function to get module item details for a particular type
 * and a particular associated curriculumProgram (if any).
 * @param {object} data
 * @param {function} data.t i18n translate function
 * @param {string} data.type module type - it will be used as a key to get the module details from typesConfig
 * @param {(object|undefined)} [data.curriculumProgramObj] curriculumProgram object if applicable - it will be used to get the program label, acronym and id to configure redirection metadata
 * @param {boolean} [data.appendAcronym=true] if true, the curriculum acronym will be appended to the title
 *
 * @returns {{id: string,title: string,subTitle: string,type: string,metadata: object,order: number}|{}} An empty object or a lowest level object that contains all the information related to search result UI and navigation metadata
 */

const getModuleObject = ({
  t,
  type,
  curriculumProgramObj,
  appendAcronym = true,
}) => {
  const {
    subTitle,
    order,
    curriculumPrograms: moduleCurriculumTypes = [],
  } = typesConfig[type];
  const { id: programId, acronym, type: programType } =
    curriculumProgramObj || {};
  const shouldAddSuffix = !_.isEmpty(curriculumProgramObj);

  const metadata = {};
  metadata.curriculumProgram = shouldAddSuffix ? programType : null;
  if (programId) {
    metadata.curriculumProgramId = programId;
  }
  if (appendAcronym && acronym) {
    metadata.acronym = acronym;
  }

  const moduleObject = {
    id: shouldAddSuffix ? `${programId}_${type}` : `0_${type}`,
    type,
    title: getModuleItemTitle({
      curriculumProgram: curriculumProgramObj,
      type,
      t,
      shouldAddSuffix,
    }),
    subTitle: t(subTitle),
    metadata,
    order,
  };

  return moduleObject;
};

const getMappedCurriculumProgram = ({ type }) => {
  const curriculumPrograms = getOrgCurriculums();

  const curriculumIds = _.map(curriculumPrograms, "id");
  let filteredCurriculum = curriculumIds;
  let skipModule = false;

  //TODO: Remove this once RNP is fully enabled.

  const isRnPConsumptionEnabled = ACLStore.can(
    ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION
  );

  if (isRnPConsumptionEnabled) {
    return curriculumPrograms;
  }

  const isAdminByRole = getIsAdminByRole();

  if (ACLStore.isStaffPermissionEnabled() && !isAdminByRole) {
    switch (type) {
      case typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_PYP.id:
      case typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_MYP.id:
      case typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_UBD.id:
      case typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_DP.id:
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "ACADEMIC_SETUP",
          curriculumIds,
        });
        break;

      case typesConfig.ADMIN_ATTENDANCE_MODULE.id:
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "ATTENDANCE",
          curriculumIds,
        });
        break;
      case typesConfig.ADMIN_REPORT_MODULE_PYP.id:
      case typesConfig.ADMIN_REPORT_MODULE_MYP.id:
      case typesConfig.ADMIN_REPORT_MODULE_UBD.id:
      case typesConfig.ADMIN_REPORT_MODULE_DP.id:
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "PROGRESS_REPORTS",
          curriculumIds,
        });
        break;
      case typesConfig.ADMIN_EDUCATION_CENTER_MODULE.id:
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "EDUCATOR_CENTER",
          curriculumIds,
        });
        break;
      case typesConfig.ADMIN_SCHOOL_POLICIES_AND_RESOURCES_MODULE.id:
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "EDUCATOR_CENTER",
          curriculumIds,
        });
        break;

      case typesConfig.HOME_PLANNING_INSIGHTS_MODULE.id:
      case typesConfig.HOME_PLANNING_INSIGHTS_MODULE_DP.id:
        filteredCurriculum = getHomeModuleAccessCurriculumIds({
          module: "PLANNING_INSIGHTS",
          curriculumIds,
        });
        break;

      case typesConfig.ADMIN_PLANNING_INSIGHTS_MODULE.id:
      case typesConfig.ADMIN_PLANNING_INSIGHTS_MODULE_DP.id:
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "PLANNING_INSIGHTS",
          curriculumIds,
        });
        break;
      case typesConfig.ADMIN_AUTH_EVALUATION.id:
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "EVALUATION_CYCLES",
          curriculumIds,
        });
        break;
      case typesConfig.ADMIN_SETTINGS_MODULE.id:
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "CURRICULUM_SETTINGS",
          curriculumIds,
        });
        break;
      case typesConfig.ADMIN_IBIS_REGISTRATION_MODULE.id:
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "IBIS_REGISTRATION",
          curriculumIds,
        });
        break;
      case typesConfig.ADMIN_IB_E_COURSEWORK_MODULE.id:
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "IB_ECOURSEWORK",
          curriculumIds,
        });
        break;
      case typesConfig.ADMIN_GRADEBOOK_MODULE.id:
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "GRADEBOOK",
          curriculumIds,
        });
        break;
      case typesConfig.HOME_GRADEBOOK_MODULE.id:
        filteredCurriculum = getHomeModuleAccessCurriculumIds({
          module: "GRADEBOOK",
          curriculumIds,
        });
        break;
      case typesConfig.ADMIN_TIMETABLE_MODULE.id:
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "TIMETABLE",
          curriculumIds,
        });
        break;
      // home module

      case typesConfig.HOME_FAMILY_MESSAGING_MODULE.id:
        filteredCurriculum = getHomeModuleAccessCurriculumIds({
          module: "FAMILY_COMMUNICATION",
          curriculumIds,
        });
        break;

      case typesConfig.HOME_AUTH_EVALUATION.id:
        filteredCurriculum = getHomeModuleAccessCurriculumIds({
          module: "EVALUATION_CYCLES",
          curriculumIds,
        });
        break;
      case typesConfig.REPORT_MODULE.id:
        filteredCurriculum = getHomeModuleAccessCurriculumIds({
          module: "PROGRESS_REPORTS",
          curriculumIds,
        });
        break;
      // admin schoolwide  module
      case typesConfig.ADMIN_SCHOOL_SETUP_MODULE.id: {
        const enabledCrriculums = getAdminPanelModuleAccessCurriculumIds({
          module: "SCHOOL_SETUP",
          curriculumIds,
        });
        skipModule = _.isEmpty(enabledCrriculums);
        break;
      }
      case typesConfig.ADMIN_STAFF_ACCESS_PERMISSION_MODULE.id: {
        const enabledCrriculums = getAdminPanelModuleAccessCurriculumIds({
          module: "STAFF_PERMISSIONS",
          curriculumIds,
        });
        skipModule = _.isEmpty(enabledCrriculums);
        break;
      }
      case typesConfig.ADMIN_BEHAVIOUR_MANAGEMENT_MODULE.id: {
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "BEHAVIOUR_MANAGEMENT",
          curriculumIds,
        });
        break;
      }

      case typesConfig.ADMIN_BEHAVIOUR_CONFIGURATION_MODULE.id: {
        filteredCurriculum = getAdminPanelModuleAccessCurriculumIds({
          module: "BEHAVIOUR_MANAGEMENT",
          curriculumIds,
        });
        break;
      }

      case typesConfig.HOME_BEHAVIOUR_MANAGEMENT_MODULE.id: {
        filteredCurriculum = getHomeModuleAccessCurriculumIds({
          module: "BEHAVIOUR_MANAGEMENT",
          curriculumIds,
        });
        break;
      }
      default:
        break;
    }
  }

  if (skipModule) {
    return [];
  }

  return _.filter(curriculumPrograms, curriculum =>
    _.includes(filteredCurriculum, curriculum.id)
  );
};

export const getModuleItems = ({ type, t, curriculumProgram, userInfo }) => {
  const isCurriculumHomeModule = _.includes(CURRICULUM_PROGRAMME, type);

  const curriculumPrograms = getMappedCurriculumProgram({
    type,
  });

  const curriculumProgramsOfType = _.filter(curriculumPrograms, {
    type: curriculumProgram,
  });

  if (!curriculumProgram && typesConfig[type]) {
    if (_.isEmpty(curriculumPrograms)) {
      return [];
    }
    const moduleObject = getModuleObject({
      t,
      type,
      appendAcronym: isCurriculumHomeModule,
    });
    return [moduleObject];
  }

  const isMultiCurriculumProgram = _.size(curriculumProgramsOfType) > 1;

  const moduleItems = _.map(curriculumProgramsOfType, program => {
    const isEnabled = checkIsModuleEnabled({
      type,
      curriculumProgram: program,
      userInfo,
    });
    if (isEnabled && typesConfig[type]) {
      return getModuleObject({
        t,
        type,
        curriculumProgramObj: program,
        appendAcronym: !isMultiCurriculumProgram && isCurriculumHomeModule,
      });
    }
  });
  return _.compact(moduleItems);
};

export const getCourseModuleItem = ({
  type,
  courseId,
  orgId,
  title,
  curriculumProgram,
  isInsightsBasedModules,
  subjectGroupType,
  subjectGroupId,
  subjectType,
  gradeId,
  t,
  profileImageData,
  learningCourse,
}) => {
  const { order, perms = [], title: moduleTitle } = typesConfig[type];
  const { id: curriculumId } = curriculumProgram;

  const isAdminByRole = getIsAdminByRole();
  if (ACLStore.isStaffPermissionEnabled() && !isAdminByRole) {
    let filteredCurriculum = [curriculumId];

    switch (type) {
      case typesConfig.REPORT_MODULE.id:
        filteredCurriculum = getHomeModuleAccessCurriculumIds({
          module: "PROGRESS_REPORTS",
          curriculumIds: [curriculumId],
        });
        break;
      default:
        break;
    }

    if (!_.includes(filteredCurriculum, curriculumId)) {
      return {};
    }
  }
  return isInsightsBasedModules
    ? {
        id: `${courseId}_${type}_${orgId}`,
        type,
        metadata: {
          courseId,
          courseName: title,
          name: t(moduleTitle),
          curriculum: curriculumId,
          subjectGroupType,
          subjectGroupId,
          subjectType,
          gradeId,
          learningCourse,
        },
        title: t(moduleTitle),
        order,
        perms,
      }
    : {
        id: `${courseId}_${type}_${orgId}`,
        type,
        metadata: {
          courseId,
          courseName: title,
          name: title,
          curriculum: curriculumId,
          profileImageData,
          learningCourse,
        },
        title,
        order,
        perms,
      };
};

export const getIsLearningCourseEnabledInGlobalSearchCurriculum = ({
  curriculumProgram,
}) => {
  const state = store?.getState();
  const currentAcademicYearId = getSelectedAcademicYearId(state);

  if (curriculumProgram?.id === "ALL") {
    const curriculumPrograms = getOrganizationCurriculumPrograms(state);

    return _.every(curriculumPrograms, curriculum =>
      getIsLearningCoursesEnabled({
        curriculumProgramId: curriculum?.id,
        academicYearId: currentAcademicYearId,
      })
    );
  }

  return getIsLearningCoursesEnabled({
    curriculumProgramId: curriculumProgram?.id,
    academicYearId: currentAcademicYearId,
  });
};

export const getModulesFiltersList = ({
  orgId,
  t,
  userInfo,
  curriculumProgram,
  useV2List = false,
}) => {
  const isGlobalSearchJumpToV2Enabled = ACLStore.can(
    "FeatureFlag:EnableGlobalSearchJumpToV2"
  );

  const isLearningCourseEnabled = getIsLearningCourseEnabledInGlobalSearchCurriculum(
    { curriculumProgram }
  );

  const baseModulesList = useV2List
    ? isGlobalSearchJumpToV2Enabled
      ? modulesAsFiltersListV3
      : modulesAsFiltersListV2
    : modulesAsFiltersList;

  //NOTE: Filtering out the Planning Insights module if Learning Course is enabled as it does not exist yet for learning courses setup

  const modulesList = isLearningCourseEnabled
    ? _.filter(
        baseModulesList,
        type => type !== typesConfig.PLANNING_INSIGHTS_MODULE.id
      )
    : baseModulesList;

  return _.reduce(
    modulesList,
    (acc, type) => {
      const isModuleEnabled = checkIsModuleEnabled({
        type,
        userInfo,
        curriculumProgram,
      });

      // NOTE: Explicitly checking 'perms` here for chip visibility since `checkIsModuleEnabled` skips 'perms' if 'controlParameterConfig' is defined
      const perms = _.get(typesConfig, [type, "perms"], []);
      const isSearchChipsEnabled = ACLStore.can(perms, "all");

      const isTypeEnabled =
        type === typesConfig.LEARNING_COURSE.id
          ? isLearningCourseEnabled
          : true;

      if (isModuleEnabled && isSearchChipsEnabled && isTypeEnabled) {
        const items = getModuleItems({ type, orgId, t, userInfo });
        if (!_.isEmpty(items)) {
          acc.push(...items);
        }
      }
      return acc;
    },
    []
  );
};

const _getTypesModulesListV2 = () => {
  const isGlobalSearchJumpToV2Enabled = ACLStore.can(
    "FeatureFlag:EnableGlobalSearchJumpToV2"
  );
  return isGlobalSearchJumpToV2Enabled
    ? _.difference(typesModulesList, CURRICULUM_PROGRAMME)
    : adminBasedModules;
};

const typesModulesListWithHomeRoutes = ({
  curriculumProgramType,
  shouldIncludeOnlyAdminModules,
  isAdminNavigationRevampEnabled,
}) => {
  const typesId = [];

  let modulesList = typesModulesList;

  if (isAdminNavigationRevampEnabled) {
    const typesModuleListForNewAdminNavigation = _.concat(
      _.filter(typesModulesList, moduleId => !_.includes(moduleId, "ADMIN")),
      ADMIN_MODULES_MOVED_TO_HOME_PAGE
    );
    modulesList = typesModuleListForNewAdminNavigation;
  } else if (shouldIncludeOnlyAdminModules) {
    modulesList = _getTypesModulesListV2();
  }
  _.forEach(modulesList, module => {
    const { curriculumPrograms = [] } = typesConfig[module];

    //if size of program and if there is intersection between org program and
    //module program is there then only append to array.
    if (_.size(curriculumPrograms)) {
      if (_.size(_.intersection(curriculumPrograms, curriculumProgramType))) {
        typesId.push(module);
      }
    } else {
      typesId.push(module);
    }
  });

  return typesId;
};

export const getModuleTypeBySearchTerm = ({
  orgId,
  curriculumProgramType,
  userInfo,
  shouldIncludeOnlyAdminModules,
  isAdminNavigationRevampEnabled,
  t,
}) => {
  //add home routes in typesmodules list
  const newRoutes = typesModulesListWithHomeRoutes({
    curriculumProgramType,
    shouldIncludeOnlyAdminModules,
    isAdminNavigationRevampEnabled,
  });

  return newRoutes.reduce((acc, key) => {
    const value = typesConfig[key];
    const { curriculumPrograms = [], excludedCurriculumPrograms = [] } = value;

    if (
      _.size(excludedCurriculumPrograms) &&
      !checkForExcludedCurriculum({
        selectedCurriculumProgramTypes: curriculumProgramType,
        type: key,
      })
    ) {
      return acc;
    }

    if (_.size(curriculumPrograms)) {
      //find intersection of org curriculum and module curriculum
      const intersectedPrograms = _.intersection(
        curriculumPrograms,
        curriculumProgramType
      );

      //for each intersected program append module of that curriculum
      _.forEach(intersectedPrograms, curr => {
        const items = getModuleItems({
          type: key,
          orgId,
          t,
          curriculumProgram: curr,
          userInfo,
        });
        if (!_.isEmpty(items)) {
          acc.push(...items);
        }
      });
    } else if (checkIsModuleEnabled({ type: key, userInfo })) {
      const items = getModuleItems({ type: key, orgId, t, userInfo });
      if (!_.isEmpty(items)) {
        acc.push(...items);
      }
    }

    return acc;
  }, []);
};

export const getCoursesBySearchTerm = ({ courses = [], orgId }) => {
  return courses.reduce((acc, currentValue) => {
    const {
      title = "",
      id: courseId,
      curriculumProgram: { id: curriculumProgramId } = {},
      profileImageData,
    } = currentValue;

    acc.push({
      id: `${courseId}_COURSE_${orgId}`,
      type: typesConfig.COURSE.id,
      metadata: {
        courseId,
        curriculum: curriculumProgramId,
        courseName: title,
        name: title,
        profileImageData,
      },
      // displayText: `Class: ${title}`,
      title,
      order: typesConfig.COURSE.order,
    });

    return acc;
  }, []);
};

export const getProjectGroupTypesLocalData = ({
  availableProjectGroupTypes,
  t,
}) => {
  return _.map(
    availableProjectGroupTypes,
    ({ type: projectGroupType, curriculumProgram }) => {
      return {
        id: `${curriculumProgram?.id}_${projectGroupType}`,
        type: projectGroupType,
        title: t(PROJECT_TYPE_LABEL_MAP_V2[projectGroupType]),
        curriculumIndicatorData: curriculumProgram,
        metadata: {
          isProjectGroupType: true,
          curriculumProgramId: curriculumProgram?.id,
        },
      };
    }
  );
};

export const ALL_CURRICULUM_INDICATOR = "ALL";

export const getIsAllCurriculumSelected = selectedCurriculumId => {
  return selectedCurriculumId === ALL_CURRICULUM_INDICATOR;
};

//this function will filter recent search data
export const filterRecentSearches = ({
  recentSearches,
  module,
  userInfo,
  t,
  selectedCurriculum,
  selectedCurriculumProgramTypes,
}) => {
  const result = [];

  _.forEach(recentSearches, search => {
    const isAllCurriculumSelected = getIsAllCurriculumSelected(
      selectedCurriculum?.id
    );

    const {
      curriculum,
      curriculumProgramId,
      isProjectGroupType = false,
    } = _.get(search, "metadata", {});

    const resultCurriculumId = curriculum || curriculumProgramId;

    const { type, id } = search;

    if (
      (!isAllCurriculumSelected &&
        resultCurriculumId &&
        !_.isEqual(resultCurriculumId, selectedCurriculum?.id)) ||
      !checkForExcludedCurriculum({
        selectedCurriculumProgramTypes,
        type,
      })
    ) {
      return;
    }

    const curriculumProgram = _.get(search, "metadata.curriculumProgram", "");

    const items = isProjectGroupType
      ? [search]
      : getModuleItems({ type, t, curriculumProgram, userInfo });

    const moduleParsedResults = parseResult({ result: items, t });
    const moduleItem =
      _.size(moduleParsedResults) > 1
        ? _.find(moduleParsedResults, { id })
        : _.first(moduleParsedResults);
    const nonModuleItem = _.first(parseResult({ result: [search], t }));

    if (module) {
      if (module === typesConfig.MODULES.id) {
        if (_.includes(typesModulesList, type)) {
          result.push(moduleItem);
        }
      } else if (
        module === type ||
        (module === typesConfig.PLANNING_INSIGHTS_MODULE.id &&
          getIsInsightsSearchV2Enabled() &&
          _.includes(insightsBasedModules, type))
      ) {
        result.push(nonModuleItem);
      }
    } else {
      if (_.includes(typesModulesList, type)) {
        result.push(moduleItem);
      } else {
        result.push(nonModuleItem);
      }
    }
  });

  return result;
};

const checkIsModuleCourseRelevant = ({ key, course }) => {
  const value = typesConfig[key];
  const { curriculumPrograms = [] } = value;
  if (_.isEmpty(curriculumPrograms)) {
    return true;
  } else {
    const courseCurriculumProgram = _.get(course, "curriculumProgram.type", "");
    return _.includes(curriculumPrograms, courseCurriculumProgram);
  }
};

const shouldSkipInsightModule = ({ key, course }) => {
  const moduleObj = typesConfig[key];
  const subjectGroupType = _.get(course, ["subjectGroups", "0", "type"]);
  const { type: subjectType } = _.get(course, ["subjects", "0"], {});

  if (!_.includes(dpInsightModules, key)) {
    return false;
  } else if (
    // We donot show Planning option in course page sidebar for these subject types
    _.includes(
      [
        SUBJECT_TYPE_CAS,
        SUBJECT_TYPE_EE,
        SUBJECT_TYPE_RP,
        SUBJECT_TYPE_SLR,
        SUBJECT_TYPE_CE,
      ],
      subjectType
    )
  ) {
    return true;
  }

  let shouldSkip = false;

  if (_.has(moduleObj, "skipForSubjectGroup")) {
    shouldSkip = _.includes(moduleObj.skipForSubjectGroup, subjectGroupType);
  }

  if (!shouldSkip && _.has(moduleObj, "skipForSubjectType")) {
    shouldSkip = _.includes(moduleObj.skipForSubjectType, subjectType);
  }

  return shouldSkip;
};
/**
 * this function will search by course module name
 * if match then it will return that module for all classes
 */
export const getCourseBasedModule = ({
  orgId,
  courses = [],
  t,
  userInfo,
  isInsightsBasedModules = false,
}) => {
  return _.reduce(
    isInsightsBasedModules ? insightsBasedModules : getCourseBasedModulesList(),
    (result, key) => {
      const modules = [];
      _.forEach(courses, course => {
        const {
          id: courseId,
          title = "",
          curriculumProgram,
          profileImageData,
          learningCourse,
        } = course;

        const subjectGroupType = _.get(course, ["subjectGroups", "0", "type"]);
        const { type: subjectType } = _.get(course, ["subjects", "0"], {});
        const subjectGroupId = _.get(
          course,
          ["subjects", "0", "subjectGroup", "id"],
          null
        );
        const grades = _.sortBy(_.get(course, "grades", {}), [
          "displaySequence",
        ]);
        const gradeId = _.get(grades, "[0].id", null);

        const isModuleEnabled = checkIsModuleEnabled({
          type: key,
          course,
          curriculumProgram,
          userInfo,
        });

        if (
          checkIsModuleCourseRelevant({ key, course }) &&
          isModuleEnabled &&
          !shouldSkipInsightModule({ key, course })
        ) {
          const courseModuleItem = getCourseModuleItem({
            type: key,
            courseId,
            orgId,
            title,
            curriculumProgram,
            isInsightsBasedModules,
            subjectGroupType,
            subjectGroupId,
            subjectType,
            gradeId,
            t,
            profileImageData,
            learningCourse,
          });
          if (!_.isEmpty(courseModuleItem)) {
            modules.push(courseModuleItem);
          }
        }
      });

      result.push(...modules);
      return result;
    },
    []
  );
};

export const getRecentSearchItems = ({
  userId,
  module,
  userInfo,
  t,
  selectedCurriculum,
  selectedCurriculumProgramTypes,
}) => {
  const { currentUserSearches } = getRecentSearches({ userId });
  const filteredSearches = filterRecentSearches({
    recentSearches: currentUserSearches,
    module,
    userInfo,
    t,
    selectedCurriculum,
    selectedCurriculumProgramTypes,
  });
  const SLICE_RESULT_COUNT = module ? 5 : 3;

  const results = _.slice(filteredSearches, 0, SLICE_RESULT_COUNT);
  return _.compact(results);
};

const getLocaleVariablesObject = ({ metadata, variables = [] }) => {
  return _.reduce(
    variables,
    (localeObject, variable) => {
      return {
        ...localeObject,
        [variable]: _.get(metadata, variable, null),
      };
    },
    {}
  );
};

const createPath = ({ type, t, metadata }) => {
  const { path, getCustomPath } = typesConfig[type];
  const modulePath = getCustomPath?.(type) ?? path;

  const pathSegments = [];
  let text = "";
  _.forEach(modulePath, data => {
    text = _.size(pathSegments) && !data.skipSlash ? ` / ` : "";
    pathSegments.push(text);
    if (data.label === "text") {
      const localeVariablesObject = getLocaleVariablesObject({
        metadata,
        variables: data.variablesForLocale,
      });
      text = t(data.value, localeVariablesObject);
      pathSegments.push(text);
    } else if (data.label === "variable") {
      text = metadata[data.value];
      pathSegments.push(text);
    } else if (data.label === "component") {
      const { Component, variables } = data;
      const props = getLocaleVariablesObject({ metadata, variables });
      pathSegments.push(<Component {...props} />);
    }
  });

  const childContent = _.map(pathSegments, PathSegment =>
    typeof PathSegment === "string" ? <span>{PathSegment}</span> : PathSegment
  );

  const wrapperDiv = _jsx("span", {
    children: childContent,
  });

  return wrapperDiv;
};

const indexBasedIconColorMapping = [
  {
    color: colors.yellow400,
    bgColor: colors.yellow950,
  },
  {
    color: colors.green300,
    bgColor: colors.green950,
  },
  {
    color: colors.teal400,
    bgColor: colors.teal950,
  },
  {
    color: colors.blue400,
    bgColor: colors.blue950,
  },
  {
    color: colors.violet400,
    bgColor: colors.violet950,
  },
  {
    color: colors.purple400,
    bgColor: colors.purple950,
  },
  {
    color: colors.pink400,
    bgColor: colors.pink950,
  },
  {
    color: colors.orange400,
    bgColor: colors.orange950,
  },
];

const getProjectGroupTypeColor = projectGroupType => {
  const iconStyle =
    projectGroupIconStyles[projectGroupType] ||
    projectGroupIconStyles.defaultStyle;

  return _.get(iconStyle, "backgroundColor");
};

const getUserId = ({ type, metadata }) => {
  switch (type) {
    case typesConfig.STUDENT_PROFILE.id:
      return _.get(metadata, "studentId");
    case typesConfig.TEACHER_PROFILE.id:
      return _.get(metadata, "teacherId");
    case typesConfig.FAMILY_PROFILE.id:
      return _.get(metadata, "parent.id");
    default:
      return null;
  }
};

const iconProps = { height: 40, width: 40 };

//this function will return image for different type
export const getImage = ({
  type,
  metadata = {},
  index,
  curriculumIndicatorData,
}) => {
  const {
    curriculumProgram,
    isProjectGroupType,
    unitName,
    unitImage,
    assessmentType,
    imageUrl,
    curriculumProgramId,
  } = metadata;

  if (isProjectGroupType) {
    return (
      <IconComponent
        color={getProjectGroupTypeColor(type)}
        icon={getIconComponent({ projectGroupType: type, iconProps })}
      />
    );
  }

  const curriculumStyles = curriculumProgram
    ? CURRICULUM_PROGRAMME_ICON_STYLES[curriculumProgram]
    : {};
  const {
    color: curriculumColor,
    className: curriculumClassName,
  } = curriculumStyles;

  const duotoneIconColor = curriculumProgram
    ? CURRICULUM_PROGRAMME_DUOTONE_ICON_COLOR_MAPPING[curriculumProgram]
    : "";

  const colorMappingSize = _.size(indexBasedIconColorMapping);
  const indexBasedColorObject = index
    ? indexBasedIconColorMapping[index % colorMappingSize]
    : indexBasedIconColorMapping[0];

  if (
    _.includes(getCourseBasedModulesList(), type) &&
    getIsClassSearchV2Enabled()
  ) {
    const isLearningCoursesEnabled = getIsLearningCoursesEnabled();
    const { courseId, learningCourseId, courseName, name, ...restMetadata } =
      metadata || {};

    return (
      <CourseIcon
        course={{
          ...restMetadata,
          id: courseId ?? learningCourseId,
          title: courseName ?? name,
        }}
        isLearningCoursesEnabled={isLearningCoursesEnabled}
      />
    );
  }

  switch (type) {
    case typesConfig.ADMIN_PANEL_MODULE.id:
      return (
        <IconComponent
          color={colors.decorativeSurfaceOneL}
          icon={
            <SortOutlined className={classes.adminSettings} size="xx-small" />
          }
        />
      );
    case typesConfig.IB_PYP.id:
    case typesConfig.IB_MYP.id:
    case typesConfig.UBD.id:
    case typesConfig.IB_DP.id: {
      return (
        <CurriculumProgramLogo
          curriculumProgramId={curriculumProgramId}
          size="medium"
        />
      );
    }
    case typesConfig.ADMIN_SCHOOL_SETUP_MODULE.id:
      return <IconComponent color={"var(--yellow-900)"} icon={<School3D />} />;

    case typesConfig.HOME_SCHOOL_LIBRARY_MODULE.id:
    case typesConfig.HOME_ANNOUNCEMENT_MODULE.id:
    case typesConfig.HOME_PROGRESS_REPORTS_MODULE_UBD.id:
    case typesConfig.HOME_PROGRESS_REPORTS_MODULE_MYP.id:
    case typesConfig.HOME_PROGRESS_REPORTS_MODULE_DP.id:
    case typesConfig.HOME_BEHAVIOUR_MANAGEMENT_MODULE.id:
    case typesConfig.HOME_SCHOOL_POLICIES_AND_RESOURCES_MODULE.id:
    case typesConfig.HOME_ATTENDANCE_MODULE.id:
    case typesConfig.HOME_HOMEROOM_MODULE.id:
    case typesConfig.HOME_CLASSROOM_MODULE.id:
    case typesConfig.HOME_CALENDAR_MODULE.id:
    case typesConfig.HOME_MESSAGING_MODULE.id:
    case typesConfig.HOME_FAMILY_MESSAGING_MODULE.id:
    case typesConfig.HOME_STUDENT_GOALS_MODULE.id:
    case typesConfig.HOME_AUTH_EVALUATION.id:
    case typesConfig.ADMIN_ANNOUNCEMENT_MODULE.id:
    case typesConfig.ADMIN_MESSAGING_MODULE.id:
    case typesConfig.ADMIN_BEHAVIOUR_MANAGEMENT_MODULE.id:
    case typesConfig.ADMIN_BEHAVIOUR_CONFIGURATION_MODULE.id:
    case typesConfig.ADMIN_EDUCATION_CENTER_MODULE.id:
    case typesConfig.ADMIN_SCHOOL_POLICIES_AND_RESOURCES_MODULE.id:
    case typesConfig.ADMIN_AUTH_EVALUATION.id:
    case typesConfig.ESF_SENTRAL_WELLBEING.id:
    case typesConfig.ESF_SENTRAL_ATTENDANCE.id:
    case typesConfig.ESF_SENTRAL_POLICIES.id:
    case typesConfig.ESF_SENTRAL_TIMETABLE.id:
    case typesConfig.ESF_SENTRAL_PXP.id:
    case typesConfig.ESF_SENTRAL_NEWSFEED.id:
    case typesConfig.ESF_SENTRAL_DAILY_NOTICE.id: {
      const iconAndColorShortcutMapping = {
        ...homeBasedModulesShortcutMapping,
        ...adminBasedModulesShortcutMapping,
      };
      const homepageFeature = iconAndColorShortcutMapping[type];
      const icon = getFeatureIcon({
        feature: homepageFeature,
        height: 40,
        width: 40,
      });
      const iconBackgroundColorStyles = FEATURE_STYLE_MAP[homepageFeature];

      return (
        <IconComponent
          icon={icon}
          iconBackgroundColorStyles={iconBackgroundColorStyles}
        />
      );
    }
    case typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_PYP.id:
    case typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_MYP.id:
    case typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_UBD.id:
    case typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_DP.id:
    case typesConfig.ADMIN_TIMETABLE_MODULE.id:
      return (
        <AcademicSetupDuotone
          color={duotoneIconColor}
          size="x-small"
          hasBackground
        />
      );
    case typesConfig.HOME_PLANNING_INSIGHTS_MODULE.id:
    case typesConfig.HOME_PLANNING_INSIGHTS_MODULE_DP.id:
    case typesConfig.ADMIN_PLANNING_INSIGHTS_MODULE.id:
    case typesConfig.ADMIN_PLANNING_INSIGHTS_MODULE_DP.id:
      return (
        <PurposeOfIntegrationDuotone
          color={duotoneIconColor}
          size="x-small"
          hasBackground
        />
      );
    case typesConfig.ADMIN_BIN_MODULE.id:
      return (
        <BinDuotone color={duotoneIconColor} size="x-small" hasBackground />
      );

    case typesConfig.ADMIN_SETTINGS_MODULE.id:
      return (
        <IconComponent
          color={colors.decorativeSurfaceOneL}
          icon={
            <SettingsOutlined className={classes.blue500} size="xx-small" />
          }
        />
      );
    case typesConfig.PLANNING_INSIGHTS_MODULE.id:
      return (
        <IconComponent
          color={indexBasedColorObject?.bgColor}
          icon={
            <InsightsSquareOutlined
              style={{
                color: indexBasedColorObject?.color,
              }}
              size="xx-small"
            />
          }
        />
      );
    case typesConfig.COURSE.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={<UnitPlanOutlined variant="subtle" size="xx-small" />}
        />
      );
    case typesConfig.CLASSROOM_MODULE.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={<AssessmentOutlined variant="subtle" size="xx-small" />}
        />
      );
    case typesConfig.JOURNAL_MODULE.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={<JournalOutlined variant="subtle" size="xx-small" />}
        />
      );
    case typesConfig.CONTINUUM_MODULE_PYP.id:
    case typesConfig.CONTINUUM_MODULE_MYP.id:
    case typesConfig.CONTINUUM_MODULE_UBD.id:
      return (
        <IconComponent
          color={curriculumColor || colors.surfaceSubtle}
          icon={
            <TickFrameOutlined
              variant="subtle"
              className={curriculumClassName}
              size="xx-small"
            />
          }
        />
      );
    case typesConfig.CLASS_SETTINGS_V2.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={<ClassSettingsOutlined variant="subtle" size="xx-small" />}
        />
      );
    case typesConfig.CALENDAR_MODULE.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={<CalendarOutlined variant="subtle" size="xx-small" />}
        />
      );
    case typesConfig.ATTENDANCE_MODULE.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={<AttendanceOutlined variant="subtle" size="xx-small" />}
        />
      );
    case typesConfig.REPORT_MODULE.id:
      return (
        <IconComponent
          color={indexBasedColorObject?.bgColor}
          icon={
            <ProgressReportOutlined
              style={{
                color: indexBasedColorObject?.color,
              }}
              size="xx-small"
            />
          }
        />
      );
    case typesConfig.UNIT_PLAN.id: {
      const imageUrl = _.get(unitImage, "value");
      return imageUrl ? (
        <Avatar
          size="medium"
          shade="light"
          shape="square"
          name={unitName}
          src={imageUrl}
          className={classes.imageContainer}
        />
      ) : (
        <IconComponent
          color={indexBasedColorObject?.bgColor}
          icon={
            <UnitPlanOutlined
              style={{
                color: indexBasedColorObject?.color,
              }}
              size="xx-small"
            />
          }
        />
      );
    }
    case typesConfig.TEACHER_RESOURCES_MODULE.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={<TeacherResourceOutlined variant="subtle" size="xx-small" />}
        />
      );
    case typesConfig.UNIT_LIBRARY_MODULE.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={<UnitLibraryOutlined variant="subtle" size="xx-small" />}
        />
      );
    case typesConfig.LE_LIBRARY_MODULE.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={<LeLibraryOutlined variant="subtle" size="xx-small" />}
        />
      );
    case typesConfig.ASSES_LEARNING_MODULE.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={
            <AssessmentandEvaluationOutlined variant="subtle" size="xx-small" />
          }
        />
      );
    case typesConfig.TEACHER_POLICIES_MODULE.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={<PolicyTickOutlined variant="subtle" size="xx-small" />}
        />
      );
    case typesConfig.CLASS_SETTINGS_MODULE.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={<ClassSettingsOutlined variant="subtle" size="xx-small" />}
        />
      );
    case typesConfig.TEACHER_NOTIFICATION_PREFERENCES_MODULE.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={
            <NotificationSettingsOutlined variant="subtle" size="xx-small" />
          }
        />
      );
    case typesConfig.MANAGE_FAMILY_MODULE.id:
      return (
        <IconComponent
          color={colors.surfaceSubtle}
          icon={<FamilyOutlined variant="subtle" size="xx-small" />}
        />
      );
    case typesConfig.ATL_MODULE.id:
      return (
        <IconComponent
          color={colors.decorativeSurfaceFourL}
          icon={<AtlDuotone color="pink" size="xx-small" />}
        />
      );
    case typesConfig.CONCEPT_INSIGHT_MODULE.id:
      return (
        <IconComponent
          color={colors.decorativeSurfaceFourL}
          icon={<KeyRelatedConceptsDuotone color="pink" size="xx-small" />}
        />
      );
    case typesConfig.THEME_DESCRIPTOR_MODULE.id:
      return (
        <IconComponent
          color={colors.decorativeSurfaceFourL}
          icon={<ThemeDescriptorInsightsDuotone color="pink" size="xx-small" />}
        />
      );
    case typesConfig.LPA_INSIGHT_MODULE.id:
      return (
        <IconComponent
          color={colors.decorativeSurfaceFourL}
          icon={<LearnerProfileDuotone color="pink" size="xx-small" />}
        />
      );
    case typesConfig.SUBJECT_INSIGHT_MODULE.id:
      return (
        <IconComponent
          color={colors.decorativeSurfaceFourL}
          icon={<SubjectGenericDuotone color="pink" size="xx-small" />}
        />
      );
    case typesConfig.POI_MODULE.id:
      return (
        <IconComponent
          color={colors.decorativeSurfaceFourL}
          icon={<ProgrammeofInquiryDuotone color="pink" size="xx-small" />}
        />
      );
    case typesConfig.SUBJECT_GROUP_OVERVIEW_MYP_INSIGHTS_MODULE.id:
    case typesConfig.POI_MYP_INSIGHTS_MODULE.id:
    case typesConfig.GLOBAL_CONTEXTS_MYP_INSIGHTS_MODULE.id:
    case typesConfig.KEY_AND_RELATED_CONCEPTS_MYP_INSIGHTS_MODULE.id:
    case typesConfig.ATL_MYP_INSIGHTS_MODULE.id:
    case typesConfig.OBJECTIVES_MYP_INSIGHTS_MODULE.id:
    case typesConfig.SUBJECT_STANDARDS_MYP_INSIGHTS_MODULE.id:
    case typesConfig.LPA_MYP_INSIGHTS_MODULE.id:
    case typesConfig.SUBJECT_GROUP_TIMELINE_MYP_INSIGHTS_MODULE.id:
    case typesConfig.UNITS_TIMELINE_VIEW_UBD_INSIGHTS_MODULE.id:
    case typesConfig.SKILLS_UBD_INSIGHTS_MODULE.id:
    case typesConfig.SYLLABUS_CONTENT_DP_INSIGHTS_MODULE.id:
    case typesConfig.SYLLABUS_OUTLINE_DP_INSIGHTS_MODULE.id:
    case typesConfig.AIMS_DP_INSIGHTS_MODULE.id:
    case typesConfig.ASSESSMENT_OBJECTIVES_DP_INSIGHTS_MODULE.id:
    case typesConfig.CONNECTIONS_DP_INSIGHTS_MODULE.id:
    case typesConfig.SUBJECT_STANDARDS_DP_INSIGHTS_MODULE.id:
    case typesConfig.LPA_DP_INSIGHTS_MODULE.id:
    case typesConfig.BENCHMARKS_DP_INSIGHTS_MODULE.id: {
      const { icon: InsightsModuleIcon } = typesConfig[type];
      return (
        <IconComponent
          color={colors.decorativeSurfaceFourL}
          icon={<InsightsModuleIcon color="pink" size="xx-small" />}
        />
      );
    }
    case typesConfig.LE.id:
    case typesConfig.ALL_STUDENT_ASSIGNMENT_SUBMISSION.id:
    case typesConfig.STUDENT_ASSIGNMENT_SUBMISSION.id:
      return (
        <AssessmentIcon
          assessmentType={assessmentType}
          curriculumType={curriculumIndicatorData?.type}
          curriculumId={curriculumIndicatorData?.id}
          isVisibleInGlobalSearch={true}
        />
      );

    case typesConfig.ADMIN_INTEGRATIONS_MODULE.id:
      return (
        <IconComponent color={"var(--pink-900)"} icon={<Integrations3D />} />
      );

    case typesConfig.ADMIN_ACADEMY_ANALYTICS_MODULE.id:
      return <IconComponent color={"var(--blue-900)"} icon={<Goals3D />} />;
    case typesConfig.ADMIN_IBIS_REGISTRATION_MODULE.id:
      return (
        <ClipboardPencilLinesDuotone
          color={duotoneIconColor}
          size="x-small"
          hasBackground
        />
      );
    case typesConfig.ADMIN_IB_E_COURSEWORK_MODULE.id:
      return (
        <SpiralBookLinesDuotone
          color={duotoneIconColor}
          size="x-small"
          hasBackground
        />
      );

    case typesConfig.HOME_GRADEBOOK_MODULE.id:
    case typesConfig.ADMIN_GRADEBOOK_MODULE.id:
      return (
        <AssessmentsDuotone
          color={duotoneIconColor}
          size="x-small"
          hasBackground
        />
      );
    case typesConfig.ADMIN_STAFF_ACCESS_PERMISSION_MODULE.id:
      return (
        <IconComponent
          color={"var(--teal-900)"}
          icon={<StaffPermissions3D />}
        />
      );
    case typesConfig.ADMIN_REPORT_MODULE_PYP.id:
    case typesConfig.ADMIN_REPORT_MODULE_MYP.id:
    case typesConfig.ADMIN_REPORT_MODULE_UBD.id:
    case typesConfig.ADMIN_REPORT_MODULE_DP.id:
      return (
        <ProgressReportDuotone
          color={duotoneIconColor}
          size="x-small"
          hasBackground
        />
      );
    case typesConfig.ADMIN_ATTENDANCE_MODULE.id:
      return (
        <AttendanceClipboardDuotone
          color={duotoneIconColor}
          size="x-small"
          hasBackground
        />
      );
    case typesConfig.ADMIN_TRANSCRIPTS_MODULE.id:
      return (
        <IconComponent color={"var(--orange-900)"} icon={<Transcripts3D />} />
      );

    case typesConfig.STUDENT_PROFILE.id:
    case typesConfig.TEACHER_PROFILE.id:
    case typesConfig.FAMILY_PROFILE.id: {
      const userId = getUserId({ type, metadata });
      return (
        <Avatar
          dsVersion="2.0"
          size="medium"
          shape="square"
          iconType="individual"
          src={imageUrl}
          id={_.toString(userId)}
        />
      );
    }
    default:
      return null;
  }
};

export const getChipImage = ({ type }) => {
  switch (type) {
    case typesConfig.MODULES.id:
      return <GridOutlined size="xxx-small" />;
    case typesConfig.UNIT_PLAN.id:
      return <UnitPlanOutlined size="xxx-small" />;
    case typesConfig.STUDENT_PROFILE.id:
      return <StudentEvaluateOutlined size="xxx-small" />;
    case typesConfig.LE.id:
      return <AssessmentOutlined size="xxx-small" />;
    case typesConfig.REPORT_MODULE.id:
      return <ClassProgressSummaryOutlined size="xxx-small" />;
    case typesConfig.PLANNING_INSIGHTS_MODULE.id:
      return <InsightsOutlined size="xxx-small" />;
  }
};

export const decideRoute = ({ type }) => {
  const module = typesConfig[type];
  const { customRoute } = module;
  if (customRoute) {
    const customRouteResult = customRoute();
    if (customRouteResult && _.includes(ROUTE_TYPES, customRouteResult)) {
      return customRouteResult;
    }
  }

  if (_.includes(CURRICULUM_PROGRAMME, type)) {
    return ROUTE_TYPES.HOMEROOTROUTE;
  } else if (_.includes(type, "HOME")) {
    return ROUTE_TYPES.HOMEROUTE;
  } else if (_.includes(type, "ADMIN")) {
    return ROUTE_TYPES.ADMINROUTE;
  } else {
    return ROUTE_TYPES.FEATUREROUTE;
  }
};

const MAP_END_POINT = {
  [typesConfig.IB_PYP.id]: "IB_PYP",
  [typesConfig.IB_MYP.id]: "IB_MYP",
  [typesConfig.UBD.id]: "UBD",
  [typesConfig.IB_DP.id]: "IB_DP",
  [typesConfig.HOME_SCHOOL_LIBRARY_MODULE.id]: "school-library",
  [typesConfig.HOME_ANNOUNCEMENT_MODULE.id]: "circulars",
  [typesConfig.HOME_PROGRESS_REPORTS_MODULE_UBD.id]: "progress-report-sets",
  [typesConfig.HOME_PROGRESS_REPORTS_MODULE_MYP.id]: "progress-report-sets",
  [typesConfig.HOME_PROGRESS_REPORTS_MODULE_DP.id]: "progress-report-sets",
  [typesConfig.HOME_BEHAVIOUR_MANAGEMENT_MODULE.id]: "behaviour-management",
  [typesConfig.HOME_SCHOOL_POLICIES_AND_RESOURCES_MODULE.id]:
    "educatorcenter_v2",
  [typesConfig.HOME_ATTENDANCE_MODULE.id]: "attendance-dashboard",
  [typesConfig.HOME_HOMEROOM_MODULE.id]: "homeroom",
  [typesConfig.HOME_CLASSROOM_MODULE.id]: "class-stream-manager",
  [typesConfig.HOME_CALENDAR_MODULE.id]: "courses/my-calendar",
  [typesConfig.HOME_MESSAGING_MODULE.id]: "messaging",
  [typesConfig.HOME_FAMILY_MESSAGING_MODULE.id]: "familyconversations",
  [typesConfig.HOME_STUDENT_GOALS_MODULE.id]: "goals",
  [typesConfig.ADMIN_SCHOOL_SETUP_MODULE.id]: "schoolSetup/school-information",
  [typesConfig.ADMIN_TRANSCRIPTS_MODULE.id]: "transcripts",
  [typesConfig.ADMIN_INTEGRATIONS_MODULE.id]: "integration-settings",
  [typesConfig.ADMIN_ACADEMY_ANALYTICS_MODULE.id]: "academy-analytics",
  [typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_PYP.id]: "academicSetup",
  [typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_MYP.id]: "mypAcademicSetup",
  [typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_UBD.id]: "ubdAcademicSetup",
  [typesConfig.ADMIN_ACADEMIC_SETUP_MODULE_DP.id]: "dpAcademicSetup",
  [typesConfig.ADMIN_TIMETABLE_MODULE.id]: "timetable",
  [typesConfig.ADMIN_PLANNING_INSIGHTS_MODULE.id]: "planningInsights",
  [typesConfig.ADMIN_PLANNING_INSIGHTS_MODULE_DP.id]: "yearGroup",
  [typesConfig.HOME_PLANNING_INSIGHTS_MODULE.id]: "planningInsights",
  [typesConfig.HOME_PLANNING_INSIGHTS_MODULE_DP.id]: "yearGroup",
  [typesConfig.ADMIN_IB_E_COURSEWORK_MODULE.id]: "ecoursework",
  [typesConfig.ADMIN_GRADEBOOK_MODULE.id]: "gradebook",
  [typesConfig.HOME_GRADEBOOK_MODULE.id]: "gradebook",
  [typesConfig.ADMIN_STAFF_ACCESS_PERMISSION_MODULE.id]: "staff-permissions",
  [typesConfig.ADMIN_BIN_MODULE.id]: "trash",
  [typesConfig.ADMIN_ANNOUNCEMENT_MODULE.id]: "circulars",
  [typesConfig.ADMIN_MESSAGING_MODULE.id]: "messaging",
  [typesConfig.ADMIN_BEHAVIOUR_MANAGEMENT_MODULE.id]: "behaviour-management",
  [typesConfig.ADMIN_BEHAVIOUR_CONFIGURATION_MODULE.id]:
    "behaviour-configuration",
  [typesConfig.ADMIN_ATTENDANCE_MODULE.id]: "attendance-dashboard",
  [typesConfig.ADMIN_REPORT_MODULE_PYP.id]: "progressreports",
  [typesConfig.ADMIN_REPORT_MODULE_MYP.id]: "progressreports",
  [typesConfig.ADMIN_REPORT_MODULE_UBD.id]: "progressreports",
  [typesConfig.ADMIN_REPORT_MODULE_DP.id]: "progressreports",
  [typesConfig.ADMIN_AUTH_EVALUATION.id]: "snp_v2",
  [typesConfig.HOME_AUTH_EVALUATION.id]: "snp_v2",
  [typesConfig.PLANNING_INSIGHTS_MODULE.id]: "planningInsights",
  [typesConfig.CLASSROOM_MODULE.id]: "classroom",
  [typesConfig.JOURNAL_MODULE.id]: "journal",
  [typesConfig.CONTINUUM_MODULE_PYP.id]: "continuum",
  [typesConfig.CONTINUUM_MODULE_MYP.id]: "continuum",
  [typesConfig.CONTINUUM_MODULE_UBD.id]: "continuum",
  [typesConfig.CLASS_SETTINGS_V2.id]: "class-settings",
  [typesConfig.CALENDAR_MODULE.id]: "my-calendar",
  [typesConfig.ATTENDANCE_MODULE.id]: "attendance",
  [typesConfig.TEACHER_RESOURCES_MODULE.id]: "teacherresources",
  [typesConfig.UNIT_LIBRARY_MODULE.id]: "unitlibrary",
  [typesConfig.LE_LIBRARY_MODULE.id]: "lelibrary",
  [typesConfig.ADMIN_EDUCATION_CENTER_MODULE.id]: "educatorcenter",
  [typesConfig.ADMIN_SCHOOL_POLICIES_AND_RESOURCES_MODULE.id]:
    "educatorcenter_v2",
  [typesConfig.ADMIN_SETTINGS_MODULE.id]: "settings",
  [typesConfig.ASSES_LEARNING_MODULE.id]: "assessmentEvaluation",
  [typesConfig.TEACHER_POLICIES_MODULE.id]: "teacherpolicies",
  [typesConfig.TEACHER_NOTIFICATION_PREFERENCES_MODULE.id]:
    "notification-preferences",
  [typesConfig.MANAGE_FAMILY_MODULE.id]: "manage-family",
  [typesConfig.ATL_MODULE.id]: "planningInsights/programmeOverview/atls",
  [typesConfig.CONCEPT_INSIGHT_MODULE.id]:
    "planningInsights/programmeOverview/keyConcepts",
  [typesConfig.THEME_DESCRIPTOR_MODULE.id]:
    "planningInsights/programmeOverview/themeFocusAreas",
  [typesConfig.LPA_INSIGHT_MODULE.id]:
    "planningInsights/programmeOverview/learnerProfile",
  [typesConfig.SUBJECT_INSIGHT_MODULE.id]:
    "planningInsights/programmeOverview/subjects",
  [typesConfig.POI_MODULE.id]: "planningInsights/programmeOverview/poi",
  [typesConfig.SUBJECT_GROUP_OVERVIEW_MYP_INSIGHTS_MODULE.id]: "sgo",
  [typesConfig.POI_MYP_INSIGHTS_MODULE.id]: "poi",
  [typesConfig.GLOBAL_CONTEXTS_MYP_INSIGHTS_MODULE.id]: "globalContexts",
  [typesConfig.KEY_AND_RELATED_CONCEPTS_MYP_INSIGHTS_MODULE.id]: "krc",
  [typesConfig.ATL_MYP_INSIGHTS_MODULE.id]: "skills",
  [typesConfig.OBJECTIVES_MYP_INSIGHTS_MODULE.id]: "objectives",
  [typesConfig.SUBJECT_STANDARDS_MYP_INSIGHTS_MODULE.id]: "standards",
  [typesConfig.LPA_MYP_INSIGHTS_MODULE.id]: "lpas",
  [typesConfig.SUBJECT_GROUP_TIMELINE_MYP_INSIGHTS_MODULE.id]: "sgo-timeline",
  [typesConfig.UNITS_TIMELINE_VIEW_UBD_INSIGHTS_MODULE.id]: "timeline",
  [typesConfig.SKILLS_UBD_INSIGHTS_MODULE.id]: "skills",
  [typesConfig.SYLLABUS_CONTENT_DP_INSIGHTS_MODULE.id]:
    "planningInsights/syllabusContent",
  [typesConfig.SYLLABUS_OUTLINE_DP_INSIGHTS_MODULE.id]:
    "planningInsights/syllabusOutline",
  [typesConfig.AIMS_DP_INSIGHTS_MODULE.id]: "planningInsights/aims",
  [typesConfig.ASSESSMENT_OBJECTIVES_DP_INSIGHTS_MODULE.id]:
    "planningInsights/assessmentObjectives",
  [typesConfig.CONNECTIONS_DP_INSIGHTS_MODULE.id]:
    "planningInsights/connections",
  [typesConfig.SUBJECT_STANDARDS_DP_INSIGHTS_MODULE.id]:
    "planningInsights/standards",
  [typesConfig.LPA_DP_INSIGHTS_MODULE.id]: "planningInsights/lpas",
  [typesConfig.BENCHMARKS_DP_INSIGHTS_MODULE.id]:
    "planningInsights/learning-outcomes",
  [typesConfig.CLASS_SETTINGS_MODULE.id]: "settings",
};

export const mapTypeToEndPoint = ({ type, metadata }) => {
  // Create dynamic MYP and UBD insights modules route
  if (_.includes(mypInsightModules, type)) {
    const subjectGroupId = _.get(metadata, "subjectGroupId", "");
    return `planningInsights/verticalOverview/${subjectGroupId}/${MAP_END_POINT[type]}`;
  }
  if (_.includes(ubdInsightModules, type)) {
    const gradeId = _.get(metadata, "gradeId", "");
    return `planningInsights/horizontalOverview/${gradeId}/${MAP_END_POINT[type]}`;
  }

  // Create dynamic route for IBIS registration module
  if (type === typesConfig.ADMIN_IBIS_REGISTRATION_MODULE.id) {
    return getIsIBISUIRevampEnabled()
      ? "ibis-registration"
      : "exam-registration";
  }
  if (type === typesConfig.COURSE.id) {
    if (getIsClassSearchV3Enabled()) {
      return "";
    }
    return "unitPlans";
  }
  if (type === typesConfig.LEARNING_COURSE.id) {
    return "";
  }

  return MAP_END_POINT[type] || "";
};

const IconComponent = props => {
  const { icon, color = "", iconBackgroundColorStyles = {} } = props;

  return (
    <div
      style={{
        backgroundColor: color,
        ...commonStyle.iconStyle,
        ...iconBackgroundColorStyles,
      }}
    >
      {icon}
    </div>
  );
};

const getFilterData = ({ state, searchText = "", module }) => {
  const academicYearSelectedId = _.get(state, "academicYearSelected.id", {});
  const orgCurriculumProgramIds = _.map(
    _.get(state, "organizationCurriculumPrograms", []),
    "id"
  );

  const platformSearchEntities = module ? [module] : [];

  const curriculumIds = orgCurriculumProgramIds;

  return {
    searchText,
    platformSearchEntities,
    maxCountPerType: 10,
    scope: "PLATFORM",
    academicYear: academicYearSelectedId,
    curriculumIds,
    metadata: {},
  };
};

export const getFilterDataMemoized = _.memoize(
  params => getFilterData(params),
  params => JSON.stringify(params)
);

const getShowStudentUIDInGlobalSearch = () =>
  ACLStore.can("FeatureFlag:ShowStudentUIDInGlobalSearch");

export const getIsStudentUIDSearchEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableStudentUIDSearchInGlobalSearch");
};

const getTeacherProfileSubtitle = ({ t, metadata, data }) => {
  const shouldShowDisplayRole =
    ACLStore.isStaffPermissionEnabled() ||
    ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);

  if (shouldShowDisplayRole && data?.subTitle) {
    return data.subTitle;
  }

  const designationId = _.get(metadata, "teacher.designation_id");

  if (designationId) {
    return t(`schoolSetup:desig_${designationId}_title`);
  }

  return t(typesConfig.TEACHER_PROFILE.subTitle);
};

const getSearchResultSubtitle = ({ type, t, metadata, data }) => {
  const isSubtitleRevampEnabled = ACLStore.can("GlobalSearch:SubtitleRevamp");

  if (isSubtitleRevampEnabled) {
    if (type === typesConfig.TEACHER_PROFILE.id) {
      return getTeacherProfileSubtitle({ t, metadata, data });
    }

    if (type === typesConfig.STUDENT_PROFILE.id && data?.subTitle) {
      return data.subTitle;
    }
  }

  if (typesConfig[type].isPath) {
    return createPath({ type, t, metadata });
  }

  let subtitle = t(typesConfig[type].subTitle);

  // TODO: Remove this flag check once enabled for all
  if (
    type === typesConfig.REPORT_MODULE.id &&
    getProgressReportSearchV2Enabled()
  ) {
    const { courseName, setType } = metadata;
    subtitle = setType === "CLASS" ? `${courseName} / ${subtitle}` : subtitle;
  }

  return subtitle;
};

const getDynamicInsightsModuleLabel = ({
  organizationCurriculumPrograms,
  curriculumProgramId,
  elementType,
}) => {
  const { plannerElementSets } =
    _.find(organizationCurriculumPrograms, {
      id: curriculumProgramId,
    }) || {};

  return _.find(plannerElementSets, {
    type: elementType,
  })?.label;
};

const getDynamicInsightsModuleLabelMemoized = _.memoize(
  params => getDynamicInsightsModuleLabel(params),
  params => JSON.stringify(params)
);

export const parseResult = ({ result, t }) => {
  const curriculumPrograms = getOrgCurriculums();
  const parsedData = _.reduce(
    result,
    (acc, data) => {
      let metadata = _.get(data, "metadata", {});

      // no need to parse project groups since they are already in this form
      const isProjectGroupType = _.get(metadata, "isProjectGroupType", false);
      if (isProjectGroupType) {
        if (getIsProjectGroupSearchEnabled()) {
          acc.push(data);
        }
        return acc;
      }

      const imageUrl = _.get(data, "metadata.imageUrl", "");
      const acronym = _.get(data, "metadata.acronym");

      const type = data.type;

      if (!typesConfig[type]) {
        return acc;
      }

      const excludeCurriculumIndicator = Boolean(
        typesConfig[type].excludeCurriculumIndicator
      );
      const order = _.get(data, "order", 1);

      const endPoint = mapTypeToEndPoint({ type, metadata });
      const routeType = decideRoute({ type });

      let title = _.get(data, "metadata.name", data.title);

      switch (type) {
        case typesConfig.TEACHER_PROFILE.id: {
          const firstName = _.get(metadata, "teacher.first_name", "");
          const middleName = _.get(metadata, "teacher.middle_name", "");
          const lastName = _.get(metadata, "teacher.last_name", "");
          const preferredName = _.get(metadata, "teacher.preferred_name", "");
          const prefix = _.get(metadata, "teacher.prefix", "");
          const suffix = _.get(metadata, "teacher.suffix", "");
          const pronouns = _.get(metadata, "teacher.pronouns", "");
          title = getFormattedUserName({
            user: {
              firstName,
              middleName,
              lastName,
              preferredName,
              prefix,
              suffix,
              pronouns,
            },
            type: "staff",
          });
          break;
        }
        case typesConfig.FAMILY_PROFILE.id: {
          const firstName = _.get(metadata, "parent.first_name", "");
          const middleName = _.get(metadata, "parent.middle_name", "");
          const lastName = _.get(metadata, "parent.last_name", "");
          const preferredName = _.get(metadata, "parent.preferred_name", "");
          const prefix = _.get(metadata, "parent.prefix", "");
          const suffix = _.get(metadata, "parent.suffix", "");
          const pronouns = _.get(metadata, "parent.pronouns", "");
          title = getFormattedUserName({
            user: {
              firstName,
              middleName,
              lastName,
              preferredName,
              prefix,
              suffix,
              pronouns,
            },
            type: "parent",
          });
          break;
        }
        case typesConfig.STUDENT_PROFILE.id: {
          const firstName = _.get(metadata, "student.first_name", "");
          const middleName = _.get(metadata, "student.middle_name", "");
          const lastName = _.get(metadata, "student.last_name", "");
          const preferredName = _.get(metadata, "student.preferred_name", "");
          const prefix = _.get(metadata, "student.prefix", "");
          const suffix = _.get(metadata, "student.suffix", "");
          const pronouns = _.get(metadata, "student.pronouns", "");
          const sourceId = _.get(metadata, "student.sourced_id", "");
          const studentAdditionalInfos = _.get(
            metadata,
            "student.additionalInfo",
            []
          );

          title = getFormattedUserName({
            user: {
              firstName,
              middleName,
              lastName,
              preferredName,
              prefix,
              suffix,
              pronouns,
              sourceId,
              studentAdditionalInfos,
            },
            type: "student",
            showStudentUID: getShowStudentUIDInGlobalSearch(),
            showAdditionalInfo: true,
          });
          break;
        }
        case typesConfig.SKILLS_UBD_INSIGHTS_MODULE.id: {
          const curriculumId = _.get(metadata, "curriculum");
          title =
            getDynamicInsightsModuleLabelMemoized({
              organizationCurriculumPrograms: curriculumPrograms,
              curriculumProgramId: curriculumId,
              elementType: "UBD_ATL",
            }) ?? title;
        }
      }

      if (_.includes(TITLE_FALLBACK_TO_EMAIL_MODULES, type) && !title) {
        title = _.get(metadata, "email", "");
      }

      if (type === typesConfig.FAMILY_PROFILE.id) {
        metadata = {
          ...metadata,
          childrenList: _.map(metadata.children, child => {
            const firstName = _.get(child, "first_name", "");
            const middleName = _.get(child, "middle_name", "");
            const lastName = _.get(child, "last_name", "");
            const preferredName = _.get(child, "preferred_name", "");
            const prefix = _.get(child, "prefix", "");
            const suffix = _.get(child, "suffix", "");
            const pronouns = _.get(child, "pronouns", "");
            return getFormattedUserName({
              user: {
                firstName,
                middleName,
                lastName,
                preferredName,
                prefix,
                suffix,
                pronouns,
              },
              type: "student",
            });
          }),
        };
      }

      metadata = {
        ...metadata,
        endPoint,
        routeType,
      };

      const subTitle = HOME_ROOT_ROUTES.includes(type)
        ? ""
        : getSearchResultSubtitle({ type, t, metadata, data });

      const additionalFields = {};
      if (acronym) {
        additionalFields.acronym = acronym;
      }
      if (metadata.email) {
        additionalFields.email = metadata.email;
      }

      const studentSourcedId = _.get(metadata, "student.sourced_id");
      const isStudentUIDSearchEnabled = getIsStudentUIDSearchEnabled();

      if (studentSourcedId && isStudentUIDSearchEnabled) {
        additionalFields.sourced_id = studentSourcedId;
      }

      if (!excludeCurriculumIndicator) {
        const { curriculum, curriculumProgramId } = metadata;
        const targetCurriculumId = curriculum || curriculumProgramId;

        const curriculumObj = _.find(
          curriculumPrograms,
          program => program.id == targetCurriculumId
        );
        additionalFields.curriculumIndicatorData = curriculumObj;
      }

      acc.push({
        id: data.id,
        type,
        title,
        subTitle,
        category:
          _.includes(insightsBasedModules, type) &&
          getIsInsightsSearchV2Enabled()
            ? `${metadata?.courseName} / ${t(
                "teacherHomePage:planning_insights"
              )}` ?? t(typesConfig[type].subTitle)
            : t(typesConfig[type].subTitle),
        order,
        imageUrl,
        metadata,
        ...additionalFields,
      });
      return acc;
    },
    []
  );

  return parsedData;
};

export const getAllConfigPerms = ({ userType, contexts }) => {
  const perms = [];
  _.forOwn(typesConfig, config => {
    if (!_.isEmpty(config.perms)) {
      perms.push(...config.perms);
    }

    const curriculumProgramType = getProgramTypeFromLocalStorageBasedOnContext(
      contexts
    );

    const controlParameterConfig = config?.controlParameterConfig;

    if (controlParameterConfig && curriculumProgramType) {
      const projectGroupType = getProjectGroupTypeBasedOnContext(contexts);

      const { configuration } = getConfigurationsFromControlParameters({
        controlParameter: controlParameterConfig?.controlParameter,
        curriculumProgramType,
        userType,
        projectGroupType,
      });

      if (configuration) {
        perms.push(_.toString(configuration));
      }
    }
  });
  return _.uniq(perms);
};

/**
 * memoization for utils function
 */
export const getParseResultMemoized = _.memoize(
  params => parseResult(params),
  params => JSON.stringify(params)
);

export const getCoursesBySearchTermMemoized = _.memoize(
  params => getCoursesBySearchTerm(params),
  params => JSON.stringify(params)
);

export const getModuleTypeBySearchTermMemoized = _.memoize(
  params => getModuleTypeBySearchTerm(params),
  params => JSON.stringify(params)
);

export const getProjectGroupTypesLocalDataMemoized = _.memoize(
  params => getProjectGroupTypesLocalData(params),
  params => JSON.stringify(params)
);

export const getCourseBasedModuleMemoized = _.memoize(
  params => getCourseBasedModule(params),
  params => JSON.stringify(params)
);

const getCourseRelatedLocalData = ({ courses, orgId, userInfo, t, module }) => {
  let coursesSuggestions = [];
  let insightsSuggestions = [];
  let courseBasedModules = [];

  const isClassSearchV3Enabled = getIsClassSearchV3Enabled();

  if (!module && !isClassSearchV3Enabled) {
    coursesSuggestions = getCoursesBySearchTermMemoized({
      courses,
      orgId,
    });
  }

  // NOTE: disabling insights suggestions for learning courses as it doesnot exit for now
  const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

  if (
    getIsInsightsSearchV2Enabled() &&
    !isLearningCoursesEnabled &&
    (!module || module === typesConfig.PLANNING_INSIGHTS_MODULE.id) &&
    isInsightsSearchEnabledInGlobalSearch()
  ) {
    insightsSuggestions = getCourseBasedModuleMemoized({
      courses,
      orgId,
      userInfo,
      isInsightsBasedModules: true,
      t,
    });
  }

  if (!module && !isClassSearchV3Enabled) {
    courseBasedModules = getCourseBasedModuleMemoized({
      courses,
      orgId,
      userInfo,
    });
  }

  const localData = [
    ...coursesSuggestions,
    ...insightsSuggestions,
    ...courseBasedModules,
  ];

  return localData;
};

const getCourseRelatedLocalDataMemoizationKey = ({
  courses,
  orgId,
  module,
}) => {
  const courseIds = _.map(courses, "id");
  return JSON.stringify({ courseIds, orgId, module });
};

const getCouseRelatedLocalDataMemoized = _.memoize(
  params => getCourseRelatedLocalData(params),
  getCourseRelatedLocalDataMemoizationKey
);

export const getAllConfigPermsMemoized = _.memoize(getAllConfigPerms);

// split the execution of the function getParsedLocalSuggestions into 3 courses batches
// to avoid blocking the main thread for long time
export const getParsedLocalSuggestionsWithTimeout = ({
  term,
  module,
  courses,
  availableProjectGroupTypes = [],
  curriculumProgramType,
  orgId,
  t,
  onComplete,
  shouldIncludeOnlyAdminModules = false,
}) => {
  if (!term) {
    onComplete?.([]);
    return;
  }

  const courseChunks = _.chunk(courses, 3);
  let currentChunkIndex = 0;

  const localData = [];

  const parseAndReturn = () => {
    const localSuggestions = getParseResultMemoized({
      result: localData,
      t,
    });
    onComplete?.(localSuggestions);
    return;
  };

  const userInfo = getUserInfo();

  if (
    (!module || module === typesConfig.MODULES.id) &&
    isModuleSearchEnabledInGlobalSearch()
  ) {
    const modulesLocalData = getModuleTypeBySearchTermMemoized({
      orgId,
      curriculumProgramType,
      userInfo,
      shouldIncludeOnlyAdminModules,
      t,
      isAdminNavigationRevampEnabled: getIsNewAdminUIEnabled(),
    });
    localData.push(...modulesLocalData);
  }

  if (
    module &&
    !(
      module === typesConfig.PLANNING_INSIGHTS_MODULE.id &&
      getIsInsightsSearchV2Enabled()
    )
  ) {
    // no need to calculate course related localData
    parseAndReturn();
    return;
  }

  if (
    !module &&
    getIsProjectGroupSearchEnabled() &&
    _.size(availableProjectGroupTypes)
  ) {
    const projectGroupTypesLocalData = getProjectGroupTypesLocalDataMemoized({
      availableProjectGroupTypes,
      t,
    });
    localData.push(...projectGroupTypesLocalData);
  }

  const getCourseChunkLocalData = () => {
    const localCourseRelatedDataChunk = getCouseRelatedLocalDataMemoized({
      courses: courseChunks[currentChunkIndex],
      orgId,
      userInfo,
      module,
      t,
    });
    localData.push(...localCourseRelatedDataChunk);
    currentChunkIndex++;

    if (currentChunkIndex < courseChunks.length) {
      setTimeout(getCourseChunkLocalData, 0);
    } else {
      parseAndReturn();
      return;
    }
  };

  getCourseChunkLocalData();
};

const getConfigUidBySrc = ({ src, configuration, ...entityData }) => {
  const {
    organizationId,
    curriculumProgramId,
    courseId,
    userId,
    identityId,
    role,
    userType,
  } = entityData;

  const shouldIncludeIdentityId =
    !_.isEmpty(identityId) &&
    _.isEqual(userType, STAFF) &&
    !_.isEqual(role, ROLE_VISITOR);

  const ENTITY_GROUPS = {
    CURRICULUM_LEVEL: [
      { entityId: curriculumProgramId, entityType: "CURRICULUM_PROGRAM" },
      { entityId: userId, entityType: "USER" },
    ],
    ORGANIZATION_LEVEL: [
      { entityId: organizationId, entityType: "ORGANIZATION" },
      { entityId: userId, entityType: "USER" },
      ...(shouldIncludeIdentityId
        ? [{ entityId: identityId, entityType: "IDENTITY" }]
        : []),
    ],
  };

  return generateConfigurationUid({
    entityGroups: ENTITY_GROUPS[src],
    configName: configuration,
  });
};

export const getConfigValue = ({ configuration, ...entityData }) => {
  const CONFIGURATION_READ_PRECEDENCE = [
    "CURRICULUM_LEVEL",
    "ORGANIZATION_LEVEL",
  ];
  for (const src of CONFIGURATION_READ_PRECEDENCE) {
    const uid = getConfigUidBySrc({ src, configuration, ...entityData });
    const configurationData = readConfigurationFragmentByUID({ uid });
    if (!_.isNil(configurationData)) {
      const configValue = parseConfigurationValue(configurationData);
      return configValue;
    }
  }
};

export const isSentralConfigEnabled = (getConfigValueProps, configuration) => {
  return getConfigValue({
    ...getConfigValueProps,
    configuration,
  });
};
